import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import HtmlParser from 'react-html-parser';

import Swal from 'sweetalert2';
import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import { apartmentReceiptPaymentModelGet } from '../../models/payments/apartmentReceiptPayment';
import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, setBadgeStatus, setBadgeStatusGeneric, numberSet, separatorsNumbersSet, styles,
    sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection, lodash,
} from '../../helpers/settings';

import { apartmentReceiptPaymentFileModelGet } from '../../models/payments/apartmentReceiptPaymentFile';
import ReceiptPerApartmentDetailEdit from '../receipts/ReceiptPerApartmentDetailEdit';
import ReceiptPerApartmentDetailAdd from '../receipts/ReceiptPerApartmentDetailAdd';
import PaymentApartmentAddEditDetails from '../payments/PaymentApartmentAddEditDetails';
import PaymentApartmentFiles from '../payments/PaymentApartmentFiles';
import BuildingHeader from '../buildings/BuildingHeader';

import Menu from '../main/Menu';
//import LoadingModalShow from '../main/LoadingModalShow';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { validationBankAccountGetAsync, validationBankGetAsync, validationPaymentMethodGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { receiptModelGet } from '../../models/receipts/receipt';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptViewModelModelGet } from '../../viewModels/apartments/apartmentReceiptViewModel';
import { receiptViewModelModelGet } from '../../viewModels/receipts/receiptViewModel';
import { apartmentReceiptDetailModelGet } from '../../models/apartments/apartmentReceiptDetail';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { expenseTemplateModelGet } from '../../models/expenses/template';
import { conceptModelGet } from '../../models/expenses/concept';
import { roleDataModelGet } from '../../models/roles/roleData';
import { paymentMethodModelGet } from '../../models/paymentMethods/paymentMethod';
import { bankModelGet } from '../../models/banks/bank';
import { bankAccountModelGet } from '../../models/bankAccounts/bankAccount';

const currentMethod = 'ApartmentReceipts';

const { app, collections: dbColle, colors, messages, icons, labels, react } = globalSettings;
const { sweetAlert2, } = react;
const { properties: dbProps, } = dbColle;
const { operators: dbOpera, } = react?.firebase;

export default function ApartmentReceipts({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let dtRowObj = {};
    let headerObj = {};
    let swalProperties = {};
    const auth = useAuth();
    const neutralValue = 0.00;
    //const history = useHistory();
    const classNameHighLightingLocal = 'bg bg-info';
    const [processType, setProcessType] = useState(-1);
    //const [modalLoading, setModalLoading] = useState({ show: false, title: '', icon: '' });
    const [btnApartementReceiptDetailsIsDisable, setBtnApartementReceiptDetailsIsDisable] = useState(true);
    const [showLoading, setShowLoading] = useState({ building: true, apartments: true, receipts: true, receipt: true, payments: true, });
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [headerSectionValues, setHeaderSectionValues] = useState(
        {
            levelOne: {
                colOne: {},
                colTwo: {},
                colThree: {
                    label: labels?.balance?.[languageObj?.id],
                    value: separatorsNumbersSet({
                        number: neutralValue,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    icon: icons?.moneyBillWave,
                    className: 'form-control bg-transparent text-black text-right',
                },
            }
        }
    );
    const fromControls = {
        bgTransparentIsValidTextBlackTextRight: 'form-control bg-transparent is-valid text-black text-right',
        bgTransparentIsWarningTextBlackTextRight: 'form-control bg-transparent is-warning text-black text-right'
    };
    const [objFind, setObjFind] = useState({ id: '', description: '', rowIndex: 0, processType: 0, subMethod: '', });
    const textHtmlObj = {
        textPrimary: `<i class='${icons?.fasFa?.tag} text-primary'></i>`,
        textWarning: `<i class='${icons?.fasFa?.tag} text-warning'></i>`,
        textSuccess: `<i class='${icons?.fasFa?.tag} text-success'></i>`,
    };
    const process = {
        edit: false,
        details: false,
        delete: false,
    };
    //#endregion variables

    //#region receipt
    const dtReceiptId = 'dtReceipt';
    let banksTwo = [];
    let bankAccountsTwo = [];
    let paymentMethodsTwo = [];
    let apartmentReceiptTwo = {};
    //let dtApartemReceiptDetailRowIndexTwo = 0;
    const [banks, setBanks] = useState([bankModelGet({})]);
    const [receipt, setReceipt] = useState(receiptModelGet({}));
    const [banksDestiny, setBanksDestiny] = useState([bankModelGet({})]);
    const [bankAccounts, setBankAccounts] = useState([bankAccountModelGet({})]);
    const [paymentMethods, setPaymentMethods] = useState([paymentMethodModelGet({})]);
    const [receiptPaymentPrintDisabled, setReceiptPaymentPrintDisabled] = useState(true);
    const [apartmentReceipt, setApartmentReceipt] = useState(apartmentReceiptModelGet({}));
    const [dtApartemReceiptDetailRowIndex, setDtApartemReceiptDetailRowIndex] = useState(0);
    const [apartmentReceiptDetailEditShowModal, setApartmentReceiptDetailEditShowModal] = useState(false);
    const [apartmentReceiptDetail, setApartmentReceiptDetail] = useState(apartmentReceiptDetailModelGet({}));
    const [apartmentReceiptDetails, setApartmentReceiptDetails] = useState([apartmentReceiptDetailModelGet({})]);
    //#endregion receipt

    //#region receipts
    const dtReceiptsId = 'dtReceipts';
    const [receiptIsOpen, setReceiptIsOpen] = useState(false);
    const [dtReceiptsRowIndex, setDtReceiptsRowIndex] = useState(0);
    const [btnReceiptsSyncDisabled, setBtnReceiptsSyncDisabled] = useState(true);
    const [apartmentsReceiptsViewModel, setApartmentsReceiptsViewModel] = useState([apartmentReceiptViewModelModelGet({})]);

    const radioReceiptBalanceOneId = 'radioReceiptBalanceOne';
    const radioReceiptBalanceTwoId = 'radioReceiptBalanceTwo';
    const radioReceiptBalanceThreeId = 'radioReceiptBalanceThree';
    const radioReceiptBalanceName = 'radioReceiptBalanceName';
    //#endregion receipts

    //#region apartment receipt payments
    const [apartmentReceiptPaymentIsDisabled, setApartmentReceiptPaymentIsDisabled] = useState(true);
    //#endregion apartment receipt payments

    //#region buildings
    const radioBuildingBalanceOneId = 'radioBuildingBalance1';
    const radioBuildingBalanceTwoId = 'radioBuildingBalance2';
    const radioBuildingBalanceThreeId = 'radioBuildingBalance3';
    const radioBuildingBalanceName = 'radioBuildingBalanceName';

    const buildingsId = 'buildingsId'
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    const [buildingBalance, setBuildingBalance] = useState(neutralValue);
    //#endregion buildings

    //#region expenseTemplate
    const [expenseTemplate, setExpenseTemplate] = useState(expenseTemplateModelGet({}));
    //#endregion expenseTemplate

    //#region apartments
    const dtApartmentsId = 'dtApartments';
    const [apartment, setApartment] = useState(apartmentModelGet({}));
    const [apartmentBalance, setApartmentBalance] = useState(neutralValue);
    const [dtApartmentsRowIndex, setDtApartmentsRowIndex] = useState(0);
    //#endregion apartments

    //#region payments
    const dtPaymentsId = 'dtPayments';
    const [totalPayments, setTotalPayments] = useState(neutralValue);
    const [paymentShowModal, setPaymentShowModal] = useState(false);
    const [dtPaymentsRowIndex, setDtPaymentsRowIndex] = useState(0);
    //const [payment, setPayment] = useState({});
    const [apartmentReceiptPayment, setApartmentReceiptPayment] = useState(apartmentReceiptPaymentModelGet({}));
    //#endregion payments

    //#region payments (attached files)
    const [apartmentReceiptPaymentFileShowModal, setApartmentReceiptPaymentFileShowModal] = useState(false);
    const [apartmentReceiptPaymentFile, setApartmentReceiptPaymentFile] = useState(apartmentReceiptPaymentFileModelGet());
    //#endregion payments (attached files)

    //#region concepts
    const dtConceptsId = 'dtConcepts';
    const [conceptsDt, setConceptsDt] = useState([]);
    const [concepts, setConcepts] = useState([conceptModelGet({})]);
    const [conceptAddShowModal, setConceptAddShowModal] = useState(false);
    //#endregion concepts

    //#region others
    const controls = {
        buttons: {
            apartmemtsFind: {
                id: 'btnApartmemtsFind',
                className: 'btn btn-outline-info btn-sm mx-1',
            },
            apartmentsGreaterThatZeroFind: {
                id: 'btnApartmemtsGreaterThatZeroFind',
                className: 'btn btn-outline-warning btn-sm',
            },
            apartmentsLessThatZeroFind: {
                id: 'btnApartmemtsLessThatZeroFind',
                className: 'btn btn-outline-success btn-sm mx-1',
            },
            apartmentReceiptsFind: {
                id: 'btnAapartmentReceiptsFind',
                className: 'btn btn-outline-secondary btn-sm',
            },
            apartmentReceiptsAllFind: {
                id: 'btnAapartmentReceiptsAllFind',
                className: 'btn btn-outline-info btn-sm mx-1',
            },
            apartmentReceiptsGreaterThatZeroFind: {
                id: 'btnApartmentReceiptsGreaterThatZeroFind',
                className: 'btn btn-outline-warning btn-sm',
            },
            apartmentReceiptsLessThatZeroFind: {
                id: 'btnApartmentReceiptsLessThatZeroFind',
                className: 'btn btn-outline-success btn-sm mx-1',
            },
            apartmentReceiptDetailFind: {
                id: 'btnApartmentReceiptDetailFind',
                className: 'btn btn-outline-primary mx-1',
            },
            apartmentReceiptDetailAdd: {
                id: 'btnApartmentReceiptDetailAdd',
                className: 'btn btn-outline-info',
            },
            apartmentReceiptPrint: {
                id: 'btnApartmentReceiptDetaiPrint',
                className: 'btn btn-outline-secondary mx-1',
            },
            apartmentReceiptDetailDelete: {
                id: 'btnApartmentReceiptDetailDelete',
                className: 'btn btn-outline-danger mx-1',
            },
            apartmentReceiptPaymentAdd: {
                id: 'btnApartmentReceiptPaymentAdd',
                className: 'btn btn-outline-success',
            },
            apartmentReceiptPaymentDelete: {
                id: 'btnApartmentReceiptPaymentDelete',
                className: 'btn btn-outline-danger mx-1',
            },
            apartmentReceiptPaymentAttachmentFiles: {
                id: 'btnApartmentReceiptPaymentAttachmentFiles',
                className: 'btn btn-outline-info',
            },
        },
        inputs: {
            // quantity: {
            //     id: 'inputApartmentReceiptDetaiQuantity',
            //     className: 'form-control text-right',
            // },
        },
        dataTables: {
            apartments: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtApartmentsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtApartmentsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
            apartmentReceipts: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtReceiptsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtReceiptsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
            apartmentReceiptDetails: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtReceiptId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtReceiptId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
            apartmentReceiptPayments: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtPaymentsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPaymentsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            apartmentsFind: {
                id: 'icoApartmentsFind',
                className: icons?.listOl,
            },
            apartmentsGreaterThatZeroFind: {
                id: 'icoApartmentsGreaterThatZeroFind',
                className: icons?.sortNumericUpAlt,
            },
            apartmentsLessThatZeroFind: {
                id: 'icoApartmentsLessThatZeroFind',
                className: icons?.sortNumericDown,
            },
            apartmentReceiptsFind: {
                id: 'icoApartmentReceiptsFind',
                className: icons?.search,
            },
            apartmentReceiptsAllFind: {
                id: 'icoApartmentReceiptsAllFind',
                className: icons?.listOl,
            },
            apartmentReceiptsGreaterThatZeroFind: {
                id: 'icoApartmentReceiptsGreaterThatZeroFind',
                className: icons?.sortNumericUpAlt,
            },
            apartmentReceiptsLessThatZeroFind: {
                id: 'icoApartmentReceiptsLessThatZeroFind',
                className: icons?.sortNumericDown,
            },
            apartmentReceiptDetailFind: {
                id: 'icoApartmentReceiptDetailFind',
                className: icons?.search,
            },
            apartmentReceiptDetailAdd: {
                id: 'icoApartmentReceiptDetailAdd',
                className: icons?.listOl,
            },
            apartmentReceiptPrint: {
                id: 'icoApartmentReceiptDetaiPrint',
                className: icons?.print,
            },
            apartmentReceiptDetailDelete: {
                id: 'icoApartmentReceiptDetailDelete',
                className: icons?.trash,
            },
            apartmentReceiptPaymentAdd: {
                id: 'icoApartmentReceiptPaymentAdd',
                className: icons?.plusCircle,
            },
            apartmentReceiptPaymentDelete: {
                id: 'icoApartmentReceiptPaymentDelete',
                className: icons?.trash,
            },
            apartmentReceiptPaymentAttachmentFiles: {
                id: 'icoApartmentReceiptPaymentAttachmentFiles',
                className: icons?.paperClip,
            },
        },
        spinners: {
            apartmentsFind: {
                id: 'spApartmentsFind',
                className: '',
            },
            apartmentsGreaterThatZeroFind: {
                id: 'spApartmentsGreaterThatZeroFind',
                className: '',
            },
            apartmentsLessThatZeroFind: {
                id: 'spApartmentsLessThatZeroFind',
                className: '',
            },
            apartmentReceiptsFind: {
                id: 'spApartmentReceiptsFind',
                className: '',
            },
            apartmentReceiptsAllFind: {
                id: 'spApartmentReceiptsAllFind',
                className: '',
            },
            apartmentReceiptsGreaterThatZeroFind: {
                id: 'spApartmentReceiptsGreaterThatZeroFind',
                className: '',
            },
            apartmentReceiptsLessThatZeroFind: {
                id: 'spApartmentReceiptsLessThatZeroFind',
                className: '',
            },
            apartmentReceiptDetailFind: {
                id: 'spApartmentReceiptDetailFind',
                className: '',
            },
            apartmentReceiptDetailAdd: {
                id: 'spApartmentReceiptDetailAdd',
                className: '',
            },
            apartmentReceiptPrint: {
                id: 'spApartmentReceiptDetaiPrint',
                className: '',
            },
            apartmentReceiptDetailDelete: {
                id: 'spApartmentReceiptDetailDelete',
                className: '',
            },
            apartmentReceiptPaymentAdd: {
                id: 'spApartmentReceiptPaymentAdd',
                className: '',
            },
            apartmentReceiptPaymentDelete: {
                id: 'spApartmentReceiptPaymentDelete',
                className: '',
            },
            apartmentReceiptPaymentAttachmentFiles: {
                id: 'spApartmentReceiptPaymentAttachmentFiles',
                className: '',
            },
        },
    };
    //#endregion others

    //#region buildings (methods)
    const buildingBalanceSetAsync = async ({ balance = neutralValue, subMethod = '', }) => {
        const currentMethod = 'buildingBalanceSetAsync';
        let response = responseGet();
        try {
            //#region methods
            headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                number: balance,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            headerSectionValues.levelOne.colThree.className = (balance === neutralValue ?
                fromControls?.bgTransparentIsValidTextBlackTextRight :
                fromControls?.bgTransparentIsWarningTextBlackTextRight);
            setHeaderSectionValues(headerSectionValues);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion buildings (metods)

    //#region apartments (methods)
    const dataTableApartmentsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableApartmentsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtApartmentsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.floor?.[languageObj?.id], width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.identifier?.[languageObj?.id], width: '75%', },
                    { title: labels?.balance?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'], [1, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentsGetAsync = async ({ e = {}, processType = 0, processType_ = 's', subMethod = '', }) => {
        const currentMethod = 'apartmentsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            let findData = false;
            let isEditLocal = false;
            let isDeleteLocal = false;
            let buildBalanceLocal = neutralValue;
            let buildingLocal = buildingModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            let apartmentsReceiptsViewModelLocal = [apartmentReceiptViewModelModelGet({})];
            if (building?.id !== buildingIdLocal || processType_ === 'b') {
                findData = true;
                setApartmentsReceiptsViewModel([]);
            }
            //#endregion variables

            setShowLoading({ building: false, apartments: true, receipts: true, receipt: true, payments: true, });

            //#region variables initialize
            dtRows = [];
            setProcessType(-1);
            setReceipt(receiptModelGet({}));
            setBuildingBalance(neutralValue);
            setBtnReceiptsSyncDisabled(true);
            setApartmentBalance(neutralValue);
            setBuilding(buildingModelGet({}));
            setApartment(apartmentModelGet({}));
            setApartmentReceipt(apartmentReceiptModelGet({}));

            response = await buildingBalanceSetAsync({
                balance: buildBalanceLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                return;
            }

            response = await dataTablesClearAsync({
                apartments: true,
                receipts: true,
                receipt: true,
                payments: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                return;
            }

            $(`#${radioReceiptBalanceOneId}`)?.prop('checked', false);
            $(`#${radioReceiptBalanceTwoId}`)?.prop('checked', false);
            $(`#${radioReceiptBalanceThreeId}`)?.prop('checked', false);
            //processType = processType_ === 's' || processType_ === 'b' ? 0 : processType;
            //#endregion variables initialize

            //#region methods
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id }) => id === buildingIdLocal) || {};
                setBuilding(buildingLocal);

                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    //#region apartments get
                    if (apartmentsReceiptsViewModel?.length <= 0 || processType_ === 'b' || findData) {
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };
                        dataObj = {
                            conditionals: [
                                { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                            ],
                            ordersBy: [
                                { field: dbProps?.floor, value: 'asc' },
                                { field: dbProps?.identifier, value: 'asc' },
                            ],
                            buildingId: buildingIdLocal,
                            languageId: languageObj?.id,
                            method: app?.backend?.methods?.apartmentsWithReceiptsAndBalance,
                            url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartments}/`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        //apartmentsLocal = response?.result || [];
                        apartmentsReceiptsViewModelLocal = response?.result || [];
                        setApartmentsReceiptsViewModel(apartmentsReceiptsViewModelLocal);
                    } else {
                        apartmentsReceiptsViewModelLocal = apartmentsReceiptsViewModel;
                    }
                    //#endregion apartments get

                    //#region add data in dtApartments
                    if (!isUndNullEmp({ data: apartmentsReceiptsViewModelLocal, subMethod: currentMethod, })?.result && apartmentsReceiptsViewModelLocal?.length > 0) {
                        //#region old code
                        // localResponse = await Promise.all(
                        //     apartmentsLocal.map(async (detail) => {
                        //         //#region data get (apartment receipt balance)
                        //         response = await apartmentReceiptBalanceGetAsync(detail?.id, detail?.buildingId);
                        //         if (response.isSuccess && !response.isWarning) {
                        //             switch (processType) {
                        //                 case 1:
                        //                     if (numberSet(response.result, 'd').result > neutralValue) {
                        //                         dtRows.push([
                        //                             detail?.floor,
                        //                             detail?.identifier,
                        //                             separatorsNumbersSet(response.result, true).result,
                        //                             buttonProcessGet(
                        //                                 detail?.id,
                        //                                 detail?.identifier,
                        //                                 true,
                        //                                 labels?.viewReceipts?.[languageObj?.id],
                        //                                 true,
                        //                                 false,
                        //                                 labels?.edit?.[languageObj?.id],
                        //                                 false,
                        //                                 false,
                        //                                 labels?.delete?.[languageObj?.id],
                        //                                 false,
                        //                                 []
                        //                             ).result,
                        //                         ]);
                        //                         buildBalanceLocal = numberSet((buildBalanceLocal + response.result), 'd').result;
                        //                     }
                        //                     break;
                        //                 case 2:
                        //                     if (numberSet(response.result, 'd').result === 0) {
                        //                         dtRows.push([
                        //                             detail?.floor,
                        //                             detail?.identifier,
                        //                             separatorsNumbersSet(response.result, true).result,
                        //                             buttonProcessGet(
                        //                                 detail?.id,
                        //                                 detail?.identifier,
                        //                                 true,
                        //                                 labels?.viewReceipts?.[languageObj?.id],
                        //                                 true,
                        //                                 false,
                        //                                 labels?.edit?.[languageObj?.id],
                        //                                 false,
                        //                                 false,
                        //                                 labels?.delete?.[languageObj?.id],
                        //                                 false,
                        //                                 []
                        //                             ).result,
                        //                         ]);
                        //                         buildBalanceLocal = numberSet((buildBalanceLocal + response.result), 'd').result;
                        //                     }
                        //                     break;
                        //                 default:
                        //                     dtRows.push([
                        //                         detail?.floor,
                        //                         detail?.identifier,
                        //                         separatorsNumbersSet(response.result, true).result,
                        //                         buttonProcessGet(
                        //                             detail?.id,
                        //                             detail?.identifier,
                        //                             true,
                        //                             labels?.viewReceipts?.[languageObj?.id],
                        //                             true,
                        //                             false,
                        //                             labels?.edit?.[languageObj?.id],
                        //                             false,
                        //                             false,
                        //                             labels?.delete?.[languageObj?.id],
                        //                             false,
                        //                             []
                        //                         ).result,
                        //                     ]);
                        //                     buildBalanceLocal = numberSet((buildBalanceLocal + response.result), 'd').result;
                        //                     break;
                        //             }
                        //         }
                        //         //#endregion data get (apartment receipt balance)
                        //         return response;
                        //     })
                        // );

                        // localResponse = localResponse.filter(({ isSuccess, isWarning }) => !isSuccess || isWarning);
                        // if (!isUndefined(localResponse) && !isNull(localResponse) && localResponse.length > 0) {
                        //     setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });

                        //     sendMessage(localResponse[0].msgType, localResponse[0].msgText, 0, true, false, null, '');
                        //     return;
                        // }
                        //#endregion old code

                        for (let apartmentReceipts of apartmentsReceiptsViewModelLocal) {
                            //#region data get (apartment receipt balance)
                            //#region old code
                            // response = await apartmentReceiptBalanceGetAsync({
                            //     apartmentId: detail?.id,
                            //     buildingId: detail?.buildingId,
                            //     subMethod: currentMethod,
                            // });

                            // if (!response?.isSuccess || response.isWarning) {
                            //     setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                            //     await sendMessageCloseCurrentWindowAsync({
                            //         msgType: response?.msgType,
                            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            //         closeWindow: false,
                            //         urlGoTo: response?.urlGoTo,
                            //         auth: auth,
                            //         isLogout: false,
                            //         languageId: languageObj?.id,
                            //         subMethod: currentMethod,
                            //     });
                            //     return;
                            // }
                            //#endregion old code

                            switch (processType) {
                                case 1:
                                    if (apartmentReceipts?.balance > neutralValue) {
                                        dtRows.push([
                                            apartmentReceipts?.floor,
                                            apartmentReceipts?.identifier,
                                            //separatorsNumbersSet(response.result, true).result,
                                            separatorsNumbersSet({
                                                number: apartmentReceipts?.balance,
                                                withDecimals: true,
                                                consoleLogErrorShow: true,
                                                subMethod: currentMethod,
                                            })?.result,
                                            buttonProcessGet({
                                                id: apartmentReceipts?.id,
                                                description: apartmentReceipts?.identifier,
                                                showDetails: true,
                                                labelDetails: labels?.viewReceipts?.[languageObj?.id],
                                                enabledDetails: true,
                                                showEdit: false,
                                                labelEdit: labels?.edit?.[languageObj?.id],
                                                enabledEdit: false,
                                                showDelete: false,
                                                labelDelete: labels?.delete?.[languageObj?.id],
                                                enabledDelete: false,
                                                processButtons: [],
                                                subMethod: currentMethod,
                                            })?.result,
                                        ]);
                                        buildBalanceLocal = numberSet({
                                            number: (buildBalanceLocal + apartmentReceipts?.balance),
                                            type: 'd',
                                            languageId: languageObj?.id,
                                            subMethod: currentMethod,
                                        })?.result;
                                    }
                                    break;
                                case 2:
                                    if (apartmentReceipts?.balance === neutralValue) {
                                        dtRows.push([
                                            apartmentReceipts?.floor,
                                            apartmentReceipts?.identifier,
                                            //separatorsNumbersSet(response.result, true).result,
                                            separatorsNumbersSet({
                                                number: apartmentReceipts?.balance,
                                                withDecimals: true,
                                                consoleLogErrorShow: true,
                                                subMethod: currentMethod,
                                            })?.result,
                                            buttonProcessGet({
                                                id: apartmentReceipts?.id,
                                                description: apartmentReceipts?.identifier,
                                                showDetails: true,
                                                labelDetails: labels?.viewReceipts?.[languageObj?.id],
                                                enabledDetails: true,
                                                showEdit: false,
                                                labelEdit: labels?.edit?.[languageObj?.id],
                                                enabledEdit: false,
                                                showDelete: false,
                                                labelDelete: labels?.delete?.[languageObj?.id],
                                                enabledDelete: false,
                                                processButtons: [],
                                                subMethod: currentMethod,
                                            })?.result,
                                        ]);
                                        buildBalanceLocal = numberSet({
                                            number: (buildBalanceLocal + apartmentReceipts?.balance),
                                            type: 'd',
                                            languageId: languageObj?.id,
                                            subMethod: currentMethod,
                                        })?.result;
                                    }
                                    break;
                                default:
                                    dtRows.push([
                                        apartmentReceipts?.floor,
                                        apartmentReceipts?.identifier,
                                        separatorsNumbersSet({
                                            number: apartmentReceipts?.balance,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: currentMethod,
                                        })?.result,
                                        buttonProcessGet({
                                            id: apartmentReceipts?.id,
                                            description: apartmentReceipts?.identifier,
                                            showDetails: true,
                                            labelDetails: labels?.viewReceipts?.[languageObj?.id],
                                            enabledDetails: true,
                                            showEdit: false,
                                            labelEdit: labels?.edit?.[languageObj?.id],
                                            enabledEdit: false,
                                            showDelete: false,
                                            labelDelete: labels?.delete?.[languageObj?.id],
                                            enabledDelete: false,
                                            processButtons: [],
                                            subMethod: currentMethod,
                                        })?.result,
                                    ]);
                                    buildBalanceLocal = numberSet({
                                        number: (buildBalanceLocal + apartmentReceipts?.balance),
                                        type: 'd',
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result;
                                    break;
                            }
                            //#endregion data get (apartment receipt balance)
                        };
                    }
                    //setBuildingBalance(numberSet(localBuildBalance, 'd').result);
                    buildBalanceLocal = numberSet({
                        number: buildBalanceLocal,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    setBuildingBalance(buildBalanceLocal);

                    response = await buildingBalanceSetAsync({
                        balance: buildBalanceLocal,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                        return;
                    }
                    //#endregion add data in dtApartments

                    setBtnReceiptsSyncDisabled(false);

                    //#region set detail, edit, delete
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result;
                    isDeleteLocal = isEditLocal;

                    setBtnApartementReceiptDetailsIsDisable(!(isEditLocal && isDeleteLocal));
                    //#endregion set detail, edit, delete
                }

                $(`#${dtApartmentsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            }
            //#endregion methods

            //#region set checked in options buttons
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                if (processType === 0 && !$(`#${radioBuildingBalanceOneId}`)?.checked) {
                    $(`#${radioBuildingBalanceOneId}`)?.prop('checked', true);
                } else if (processType === 1 && !$(`#${radioBuildingBalanceTwoId}`)?.checked) {
                    $(`#${radioBuildingBalanceTwoId}`)?.prop('checked', true);
                } else if (processType === 2 && !$(`#${radioBuildingBalanceThreeId}`)?.checked) {
                    $(`#${radioBuildingBalanceThreeId}`)?.prop('checked', true);
                }
            } else {
                $(`#${radioBuildingBalanceOneId}`)?.prop('checked', false);
                $(`#${radioBuildingBalanceTwoId}`)?.prop('checked', false);
                $(`#${radioBuildingBalanceThreeId}`)?.prop('checked', false);
            }
            //#endregion set checked in options buttons

            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const apartmentReceiptBalanceGetAsync = async ({ apartmentId = '', buildingId = '', subMethod = '', }) => {
    //     const currentMethod = 'apartmentReceiptBalanceGetAsync';
    //     let response = responseGet();
    //     try {
    //         //#region variables
    //         let apartmentReceiptsLocal = [apartmentReceiptModelGet({})];
    //         //#endregion variables

    //         //#region data get
    //         headersObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };
    //         dataObj = {
    //             conditionals: [
    //                 { field: 'apartmentId', operator: dbOpera?.equalTo, value: `${apartmentId}`, },
    //             ],
    //             ordersBy: [
    //                 { field: 'receiptNumberApartment', value: 'asc', },
    //             ],
    //             buildingId: buildingId,
    //             url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceipts}/`,
    //         };

    //         result = await axios?.post(
    //             dataObj?.url,
    //             dataObj,
    //             headersObj,
    //         );

    //         response = result?.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             return response;
    //         }

    //         apartmentReceiptsLocal = response.result || [];
    //         //#endregion data get

    //         //#region calculate balance
    //         if (!isUndNullEmp({ data: apartmentReceiptsLocal, subMethod: currentMethod, })?.result && apartmentReceiptsLocal?.length > 0) {
    //             //response.result = numberSet(sumBy(apartmentReceiptsLocal, 'balance'), 'd').result;
    //             response.result = numberSet({
    //                 number: lodash?.sum({
    //                     data: apartmentReceiptsLocal,
    //                     key: dbProps?.balance,
    //                     consoleLogErrorShow: true,
    //                     subMethod: currentMethod,
    //                 })?.result,
    //                 type: 'd',
    //                 languageId: languageObj?.id,
    //                 subMethod: currentMethod,
    //             })?.result;
    //         } else {
    //             //response.result = numberSet('', 'd').result;
    //             response.result = numberSet({
    //                 number: neutralValue,
    //                 type: 'd',
    //                 languageId: languageObj?.id,
    //                 subMethod: currentMethod,
    //             })?.result;
    //         }
    //         //#endregion calculate balance
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion apartments (methods)

    //#region receipt (methods)
    const dataTableReceiptSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableReceiptSetAsync';
        let response = responseGet();
        try {
            $(`#${dtReceiptId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.concept?.[languageObj?.id], width: '35%', },
                    { title: labels?.quantity?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.amount?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.subTotal?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtReceiptsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentReceiptGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ apartments: false, receipts: true, receipt: true, payments: true, });

            //#region variables
            let dtPaymentRows = [];
            let buildingIdLocal = '';
            let dtReciptDetailRows = [];
            let isEditDeleteLocal = false;
            let apartmentReceiptPaymentFind = apartmentReceiptPaymentModelGet({});
            let apartmentReceiptViewModelLocal = apartmentReceiptViewModelModelGet({});
            let finalData = {
                receipt: receiptModelGet({}),
                expenseConcepts: [conceptModelGet({})],
                expenseTemplate: expenseTemplateModelGet({}),
                expenseTemplateApartment: expenseTemplateModelGet({}),
                apartmentReceipt: apartmentReceiptModelGet({}),
                apartmentUsers: [apartmentUserModelGet({})],
                apartmentReceiptDetails: [{
                    ...apartmentReceiptDetailModelGet({}),
                    total: 0.00,
                    totalGeneral: 0.00,
                    process: {
                        edit: false,
                        details: false,
                        delete: false,
                    },
                    expenseConcept: conceptModelGet({}),
                }],
                apartmentReceiptPayments: [{
                    ...apartmentReceiptPaymentModelGet({}),
                    process: {
                        edit: false,
                        details: false,
                        delete: false,
                    },
                }],
                roleData: roleDataModelGet({}),
            };
            //#endregion variables

            //#region Iitialization
            setReceipt({});
            setProcessType(-1);
            setDtReceiptsRowIndex(0);
            dtReciptDetailRows = [];
            setTotalPayments(neutralValue);
            setReceiptPaymentPrintDisabled(true);
            buildingIdLocal = $(`#${buildingsId}`)?.val();
            response = await dataTablesClearAsync({
                apartments: false,
                receipts: false,
                receipt: true,
                payments: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ apartments: false, receipts: false, receipt: false, payments: false, });
                return;
            }

            finalData = {
                receipt: {},
                expenseConcepts: [],
                expenseTemplate: {},
                apartmentReceipt: {},
                apartmentUsers: [],
                apartmentReceiptDetails: [],
                apartmentReceiptPayments: [],
                roleData: {},
            };
            //#endregion Initialization

            //#region data get (receipt per apartment)
            apartmentReceiptViewModelLocal = apartmentsReceiptsViewModel?.find(({ id: idLocal, }) => idLocal === apartment?.id,) || {};
            finalData.receipt = apartmentReceiptViewModelLocal?.receipts?.find(({ id: idLocal }) => idLocal === id)?.receipt || {};

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentReceiptId: id,
                receipt: finalData?.receipt,
                languageId: languageObj?.id,
                method: app?.backend?.methods?.apartmentReceiptWithFullDetails,
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceipts}/`
            }

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ apartments: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            finalData = response?.result || {};
            finalData.apartmentUsers = finalData?.apartmentUsers?.filter(({ userId, }) => userId === auth?.user?.uid) || {};
            setApartmentReceiptPaymentIsDisabled(finalData?.roleData?.isMaster || finalData?.roleData?.isAdmin ?
                false :
                finalData?.apartmentUsers?.length > 0 ?
                    false :
                    true
            );

            apartmentReceiptTwo = finalData?.apartmentReceipt;
            setApartmentReceipt(apartmentReceiptTwo);
            //#endregion data get (receipt per apartment)

            //#region data get (receipt)
            setReceipt(finalData?.receipt);
            setReceiptIsOpen(finalData?.receipt?.isOpen || false);
            //#endregion data get (receipt)

            //#region set is edit / delete
            isEditDeleteLocal = !isUndNullEmp({ data: finalData?.receipt?.isOpen, subMethod: currentMethod, })?.result ?
                finalData?.receipt?.isOpen ?
                    !isUndNullEmp({ data: finalData?.receipt?.balance, subMethod: currentMethod, })?.result &&
                        !isUndNullEmp({ data: finalData?.receipt?.total, subMethod: currentMethod, })?.result ?
                        finalData?.receipt?.balance === finalData?.receipt?.total :
                        false :
                    false :
                false;
            //#endregion set is edit / delete

            //#region data get (expense template)
            setExpenseTemplate(finalData?.expenseTemplate);
            //#endregion data get (expense template)

            //#region dataTable addData receipt (details)
            //#region old code
            // if (!isUndNullEmp({ data: finalData?.expenseTemplate, subMethod: currentMethod, })?.result &&
            //     finalData?.expenseTemplate.details?.length > 0) {
            //     finalData?.expenseTemplate.details?.forEach((detail) => {
            //         //#region variables
            //         const expenseTemplatePrice = numberSet({
            //             number: (detail?.price / (finalData?.receipt?.receiptGenerateds > neutralValue ? finalData?.receipt?.receiptGenerateds : 1.00)),
            //             type: 'd',
            //             languageId: languageObj?.id,
            //             subMethod: currentMethod,
            //         })?.result;
            //         const dtRowObj = {
            //             quantity: separatorsNumbersSet({
            //                 number: detail?.quantity,
            //                 withDecimals: true,
            //                 consoleLogErrorShow: true,
            //                 subMethod: currentMethod,
            //             }).result,
            //             price: separatorsNumbersSet({
            //                 number: expenseTemplatePrice,
            //                 withDecimals: true,
            //                 consoleLogErrorShow: true,
            //                 subMethod: currentMethod,
            //             }).result,
            //             subTotal: separatorsNumbersSet({
            //                 number: numberSet({
            //                     number: (expenseTemplatePrice * detail?.quantity),
            //                     type: 'd',
            //                     languageId: languageObj?.id,
            //                     subMethod: currentMethod,
            //                 })?.result,
            //                 withDecimals: true,
            //                 consoleLogErrorShow: true,
            //                 subMethod: currentMethod,
            //             }).result,
            //         };
            //         //const localPrice = numberSet((detail?.price / (finalData?.receipt.receiptGenerateds > neutralValue ? finalData?.receipt.receiptGenerateds : 1.00)), 'd').result;
            //         //const localSubTotal = numberSet((localPrice * detail?.quantity), 'd').result;
            //         //#endregion variables

            //         //#region methods
            //         dtReciptDetailRows.push([
            //             detail?.description,
            //             dtRowObj?.quantity,
            //             dtRowObj?.price,
            //             dtRowObj?.subTotal,
            //             buttonProcessGet({
            //                 id: detail?.id,
            //                 description: detail?.description,
            //                 showDetails: false,
            //                 labelDetails: labels?.detail?.[languageObj?.id],
            //                 enabledDetails: false,
            //                 showEdit: true,
            //                 labelEdit: labels?.edit?.[languageObj?.id],
            //                 enabledEdit: false,
            //                 showDelete: true,
            //                 labelDelete: labels?.delete?.[languageObj?.id],
            //                 enabledDelete: false,
            //                 processButtons: [],
            //                 subMethod: currentMethod,
            //             })?.result,
            //         ]);
            //         //#endregion methods
            //     })
            // };
            //#endregion old code

            if (!isUndNullEmp({ data: finalData?.expenseTemplateApartment, subMethod: currentMethod, })?.result) {
                finalData?.expenseTemplateApartment.details?.forEach((detail) => {
                    //#region variables
                    //#region old code
                    // const expenseTemplatePrice = numberSet({
                    //     number: (detail?.price / (finalData?.receipt?.receiptGenerateds > neutralValue ? finalData?.receipt?.receiptGenerateds : 1.00)),
                    //     type: 'd',
                    //     languageId: languageObj?.id,
                    //     subMethod: currentMethod,
                    // })?.result;
                    //#endregion old code
                    const expenseTemplatePrice = detail?.price;
                    const dtRowObj = {
                        quantity: separatorsNumbersSet({
                            number: detail?.quantity,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        }).result,
                        price: separatorsNumbersSet({
                            number: expenseTemplatePrice,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        }).result,
                        subTotal: separatorsNumbersSet({
                            number: numberSet({
                                number: (expenseTemplatePrice * detail?.quantity),
                                type: 'd',
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        }).result,
                    };
                    //const localPrice = numberSet((detail?.price / (finalData?.receipt.receiptGenerateds > neutralValue ? finalData?.receipt.receiptGenerateds : 1.00)), 'd').result;
                    //const localSubTotal = numberSet((localPrice * detail?.quantity), 'd').result;
                    //#endregion variables

                    //#region methods
                    dtReciptDetailRows.push([
                        detail?.description,
                        dtRowObj?.quantity,
                        dtRowObj?.price,
                        dtRowObj?.subTotal,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: false,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: false,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: false,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: false,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                    //#endregion methods
                })
            };

            setDtReceiptsRowIndex(rowIndex);
            //#endregion dataTable addData receipt (details)

            //#region dataTable addData apartmentReceipt (details)
            setApartmentReceiptDetails(finalData?.apartmentReceiptDetails);
            if (!isUndNullEmp({ data: finalData?.apartmentReceiptDetails, subMethod: currentMethod, })?.result &&
                finalData?.apartmentReceiptDetails?.length > 0) {
                //#region dataTable data set
                for (let detail of finalData?.apartmentReceiptDetails) {
                    //#region variables
                    const dtRowObj = {
                        quantity: separatorsNumbersSet({
                            number: detail?.quantity,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        price: separatorsNumbersSet({
                            number: detail?.price,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        total: separatorsNumbersSet({
                            number: detail?.total,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    }
                    //#endregion variables

                    //#region methods
                    dtReciptDetailRows.push([
                        detail?.expenseConcept?.description,
                        dtRowObj?.quantity,
                        dtRowObj?.price,
                        dtRowObj?.total,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.expenseConcept?.description,
                            showDetails: false,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: false,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            //#region old code
                            // enabledEdit: processEvaluateGet({
                            //     object: detail,
                            //     property: labels?.process?.en?.toLowerCase(),
                            //     process: labels?.edit?.en?.toLowerCase(),
                            //     subMethod: currentMethod
                            // })?.result && isEditDeleteLocal,
                            //#endregion old code
                            enabledEdit: detail?.process?.edit && isEditDeleteLocal,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            //#region old code
                            // enabledDelete: processEvaluateGet({
                            //     object: detail,
                            //     property: labels?.process?.en?.toLowerCase(),
                            //     process: labels?.delete?.en?.toLowerCase(),
                            //     subMethod: currentMethod
                            // })?.result && isEditDeleteLocal,
                            //#endregion old code
                            enabledDelete: detail?.process?.delete && isEditDeleteLocal,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                    //#endregion methods
                };
                //#endregion dataTable data set
            };

            $(`#${dtReceiptId}`)?.DataTable()?.rows?.add(dtReciptDetailRows)?.draw(true);
            //#endregion dataTable addData apartmentReceipt (details)

            //#region data get (payment method)
            response = await paymentsDataGetAsync({
                buildingId: buildingIdLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ apartments: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data get (payment method)

            //#region data get (apartment receipt payments)
            //#region old code
            // dataObj = {
            //     conditionals: [
            //         { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${finalData?.buildingId}` },
            //         { field: dbProps?.apartmentId, operator: dbOpera?.equalTo, value: `${finalData?.apartmentId}` },
            //         { field: dbProps?.apartmentReceiptId, operator: dbOpera?.equalTo, value: `${finalData?.id}` },
            //     ],
            //     ordersBy: [
            //         { field: dbProps?.date, value: 'asc' },
            //     ],
            //     buildingId: finalData?.apartmentReceipt?.buildingId,
            //     apartmentId: finalData?.apartmentReceipt?.apartmentId,
            // };

            // //result = await axios?.post(`${app?.backend?.urlDev}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/`, localData, headerObj);
            // result = await axios?.post(`${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/`, dataObj, headersObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // finalData?.apartmentReceiptPayments = response.result;
            // if (!isUndefined(finalData?.apartmentReceiptPayments) && !isNull(finalData?.apartmentReceiptPayments) && finalData?.apartmentReceiptPayments.length > 0) {
            //     setTotalPayments(numberSet((sumBy(finalData?.apartmentReceiptPayments, 'amount')), 'd').result);

            //     map(finalData?.apartmentReceiptPayments, (detail) => {
            //         //#region payment type get

            //         const localPaymentMethod = paymentMethodsTwo.filter(({ id }) => id === detail?.paymentMethodId)[0].description;
            //         const localConcilationStatus = isEmpty(detail?.concilationStatus) ?
            //             `<i class='fas fa-tag text-primary'></i>` : (detail?.concilationStatus === 'W' ?
            //                 `<i class='fas fa-tag text-warning'></i>` : `<i class='fas fa-tag text-success'></i>`);

            //         //#endregion payment type get

            //         localProcessButtons = [{
            //             isVisible: true,
            //             isEnabled: true,
            //             showDivider: true,
            //             methodName: 'attachedFiles',
            //             icon: icons?.paperClip,
            //             label: labels?.paymentSupportsAbbreviation?.[languageObj?.id],
            //         }];

            //         localPayments.push([
            //             dateTimeFormatGlobalSet(detail?.date, globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo, 24, false).result,
            //             `${localConcilationStatus}${globalSettings?.html?.space?.formatOne}${localPaymentMethod}`,
            //             dateTimeFormatGlobalSet(detail?.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
            //             separatorsNumbersSet(detail?.amount, true).result,
            //             buttonProcessGet(
            //                 detail?.id,
            //                 detail?.reference,
            //                 true,
            //                 labels?.detail?.[languageObj?.id],
            //                 true,
            //                 true,
            //                 labels?.edit?.[languageObj?.id],
            //                 //(detail?.concilationStatus !== 'S'),
            //                 //(detail?.concilationStatus !== 'S') && (localRoleData.isAdmin || localRoleData.isMaster) &&
            //                 (detail?.concilationStatus !== 'S') &&
            //                 processEvaluateGet(detail, labels?.process?.en?.toLowerCase(), labels?.edit?.en?.toLowerCase(), currentMethod).result,
            //                 true,
            //                 labels?.delete?.[languageObj?.id],
            //                 //(detail?.concilationStatus !== 'S'),
            //                 //(detail?.concilationStatus !== 'S') && (localRoleData.isAdmin || localRoleData.isMaster) &&
            //                 (detail?.concilationStatus !== 'S') &&
            //                 processEvaluateGet(detail, labels?.process?.en?.toLowerCase(), labels?.delete?.en?.toLowerCase(), currentMethod).result,
            //                 localProcessButtons
            //             ).result
            //         ]);
            //     });

            //     //#region check is receipt is reconciled

            //     localPaymentsIsNotConcilied = finalData?.apartmentReceiptPayments.filter(({ concilationStatus }) => (concilationStatus === 'W' || isEmpty(concilationStatus)));
            //     setReceiptPaymentPrintDisabled((!isUndefined(localPaymentsIsNotConcilied) && localPaymentsIsNotConcilied.length > 0));
            //     //setReceiptPaymentPrintDisabled(false);

            //     //#endregion check is receipt is reconciled
            // }

            // $(`#${dtPaymentsId}`)?.DataTable()?.rows?.add(localPayments)?.draw(true);
            //#endregion old code

            if (!isUndNullEmp({ data: finalData?.apartmentReceiptPayments, subMethod: currentMethod, })?.result &&
                finalData?.apartmentReceiptPayments?.length > 0) {
                //#region totalPayments get
                //#region old code
                // const totalPaymentsLocal =
                //     numberSet({
                //         number: lodash?.sum({
                //             data: finalData?.apartmentReceiptPayments,
                //             key: dbProps?.amount,
                //             consoleLogErrorShow: true,
                //             subMethod: currentMethod,
                //         })?.result,
                //         type: 'd',
                //         languageId: languageObj?.id,
                //         subMethod: currentMethod,
                //     })?.result;
                //#endregion old code
                setTotalPayments(
                    numberSet({
                        number: lodash?.sum({
                            data: finalData?.apartmentReceiptPayments,
                            key: dbProps?.amount,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result
                );
                //#endregion totalPayments get

                for (let detail of finalData?.apartmentReceiptPayments) {
                    //#region payment type get
                    const paymentMethodLocal = paymentMethodsTwo.find(({ id }) => id === detail?.paymentMethodId)?.description || '';
                    const concilationStatusLocal = isUndNullEmp({ data: detail?.concilationStatus, subMethod: currentMethod, })?.result ?
                        textHtmlObj?.textPrimary :
                        detail?.concilationStatus === 'W' ?
                            textHtmlObj?.textWarning :
                            textHtmlObj?.textSuccess;
                    //#endregion payment type get

                    //#region variables
                    const dtRowObj = {
                        dateTime: dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                            format: 24,
                            addTime: false,
                            secondsShow: false,
                            subMethod: currentMethod,
                        })?.result,
                        type: `${concilationStatusLocal}${globalSettings?.html?.space?.formatOne}${paymentMethodLocal}`,
                        date: dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            subMethod: currentMethod,
                        })?.result,
                        amount: separatorsNumbersSet({
                            number: detail?.amount,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        processButtons: [{
                            isVisible: true,
                            isEnabled: true,
                            showDivider: true,
                            methodName: app?.backend?.methods?.attachedFiles,
                            icon: icons?.paperClip,
                            label: labels?.paymentSupportsAbbreviation?.[languageObj?.id],
                        }],
                    };
                    //#endregion variables

                    //#region methods
                    dtPaymentRows.push([
                        dtRowObj?.dateTime,
                        dtRowObj?.type,
                        dtRowObj?.date,
                        dtRowObj?.amount,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.reference,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            //#region old code
                            // enabledEdit: detail?.concilationStatus !== 'S' &&
                            //     processEvaluateGet({
                            //         object: detail,
                            //         property: labels?.process?.en?.toLowerCase(),
                            //         process: labels?.edit?.en?.toLowerCase(),
                            //         subMethod: currentMethod,
                            //     })?.result,
                            //#endregion old code
                            enabledEdit: detail?.concilationStatus !== 'S' && detail?.process?.edit,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            //#region old code
                            // enabledDelete: detail?.concilationStatus !== 'S' &&
                            //     processEvaluateGet({
                            //         object: detail,
                            //         property: labels?.process?.en?.toLowerCase(),
                            //         process: labels?.delete?.en?.toLowerCase(),
                            //         subMethod: currentMethod,
                            //     })?.result,
                            //#endregion old code
                            enabledDelete: detail?.concilationStatus !== 'S' && detail?.process?.delete,
                            processButtons: dtRowObj?.processButtons,
                            subMethod: currentMethod,
                        })?.result
                    ]);
                    //#endregion methods
                };

                //#region check is receipt is reconciled
                // paymentsIsNotConciliedLocal = finalData?.apartmentReceiptPayments.filter(({ concilationStatus }) => (concilationStatus === 'W' || isUndNullEmp({ data: concilationStatus, subMethod: currentMethod, })?.result));
                // setReceiptPaymentPrintDisabled((!isUndefined(paymentsIsNotConciliedLocal) && paymentsIsNotConciliedLocal.length > 0));
                // //setReceiptPaymentPrintDisabled(false);
                apartmentReceiptPaymentFind = finalData?.apartmentReceiptPayments.find(({ concilationStatus }) => (concilationStatus === 'W' || isUndNullEmp({ data: concilationStatus, subMethod: currentMethod, })?.result));
                setReceiptPaymentPrintDisabled(!isUndNullEmp({ data: apartmentReceiptPaymentFind?.id, subMethod: currentMethod, })?.result);
                //setReceiptPaymentPrintDisabled(false);
                //#endregion check is receipt is reconciled
            }

            $(`#${dtPaymentsId}`)?.DataTable()?.rows?.add(dtPaymentRows)?.draw(true);
            //#endregion data get (apartment receipt payments)

            setShowLoading({ apartments: false, receipts: false, receipt: false, payments: false, });
        } catch (ex) {
            setShowLoading({ apartments: false, receipts: false, receipt: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentReceiptDetailEditGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptDetailEditGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: false, receipts: false, receipt: true, payments: false, });

            //#region variables
            let apartmentReceiptDetailLocal = {
                ...apartmentReceiptDetailModelGet({}),
                description: '',
            };
            //#endregion variables

            //#region variables initialize
            setDtApartemReceiptDetailRowIndex(0);
            //dtApartemReceiptDetailRowIndexTwo = 0;
            setApartmentReceiptDetail(apartmentReceiptDetailModelGet({}));
            //#endregion variables initialize

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptDetails}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceiptDetailLocal = response?.result || {};
            //#endregion data get

            //#region data set
            apartmentReceiptDetailLocal.description = description
            setDtApartemReceiptDetailRowIndex(rowIndex);
            //dtApartemReceiptDetailRowIndexTwo = rowIndex;
            setApartmentReceiptDetail(apartmentReceiptDetailLocal);
            //#endregion final data set

            setApartmentReceiptDetailEditShowModal(true);
            setShowLoading({ building: false, receipts: false, receipt: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, receipts: false, receipt: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const apartmentReceiptDetailDeleteGetAsync = async ({
    //     id = '', 
    //     description = '', 
    //     rowIndex = 0,
    //     subMethod = '',
    // }) => {
    //     const currentMethod = 'apartmentReceiptDetailDeleteGetAsync';
    //     let response = responseGet();
    //     try {
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region variables initialize

    //         setDtApartemReceiptDetailRowIndex(0);
    //         //dtApartemReceiptDetailRowIndexTwo = 0;
    //         setApartmentReceiptDetail({});

    //         //#endregion variables initialize

    //         response.msgText = `${labels?.detail?.[languageObj?.id]}: <b>${description}</b><br/>`;
    //         response.msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: response.msgText,
    //             timer: null,
    //             confirmButtonColor: colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         if (isConfirmed) {
    //             localApartmentReceiptDetailDeletePost(id, description, rowIndex);
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: apartmentReceiptDetailDeleteGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localApartmentReceiptDetailDeletePost = (id = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         setDtApartemReceiptDetailRowIndex(rowIndex);
    //         //dtApartemReceiptDetailRowIndexTwo = rowIndex;
    //         setApartmentReceiptDetail({ ...apartmentReceiptDetail, id: id, description: description, });
    //         $(`#${controls?.buttons?.apartmentReceiptDelete?.id}`)?.trigger('click');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localApartmentReceiptDetailDeletePost<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    const apartmentReceiptDetailDeletePostAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRowObj = {};
            let conceptTotalLocal = neutralValue;
            let buildingBalanceLocal = neutralValue;
            let apartmentBalanceLocal = neutralValue;
            let buildingBalanceTotalLocal = neutralValue;
            let apartmentBalanceTotalLocal = neutralValue;
            let apartmentReceiptTotalLocal = neutralValue;
            let apartmentReceiptBalanceLocal = neutralValue;
            let apartmentReceiptLocal = apartmentReceiptModelGet({});
            let apartmentReceiptDetailLocal = apartmentReceiptDetailModelGet({});
            let apartmentReceiptDetailsLocal = [apartmentReceiptDetailModelGet({})];
            //#endregion variables

            //#region initialize
            //#endregion initialize

            //#region show message
            let msgTextObj = {
                one: `${labels?.detail?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region apartmentReceiptDetail (delete)
                        //#region data (delete)
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptDetails}/${id}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ building: false, receipts: false, receipt: false, payments: false, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        apartmentReceiptLocal = response?.result?.apartmentReceipt || {};
                        conceptTotalLocal = response?.result?.conceptTotal || neutralValue;
                        apartmentReceiptDetailLocal = response?.result?.apartmentReceiptDetail || {};
                        apartmentReceiptBalanceLocal = response?.result?.apartmentReceipt?.balance || neutralValue;
                        apartmentReceiptTotalLocal = response?.result?.apartmentReceipt?.total || neutralValue;
                        setApartmentReceiptDetail(apartmentReceiptDetailLocal);

                        apartmentReceiptDetailsLocal = apartmentReceiptDetails?.filter(({ id: idLocal }) => idLocal !== id);
                        setApartmentReceiptDetails(apartmentReceiptDetailsLocal);
                        setApartmentReceipt({
                            ...apartmentReceiptLocal,
                            [dbProps?.balance]: apartmentReceiptBalanceLocal,
                            [dbProps?.total]: apartmentReceiptTotalLocal,
                        });
                        //#endregion data (delete)

                        //#region remove record to dtReceipt
                        $(`#${dtReceiptId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion Remove record to dtReceipt

                        //#region update record dtReceipts
                        //#region variables
                        dtRowObj = {
                            receiptNumberApartment: apartmentReceiptLocal?.receiptNumberApartment,
                            from: dateTimeFormatGlobalSet({
                                date: receipt?.from,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            //separatorsNumbersSet(apartmentReceiptTotalLocal, true).result,
                            total: separatorsNumbersSet({
                                number: apartmentReceiptTotalLocal,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                            //setBadgeStatusGeneric((apartmentReceiptBalanceLocal > neutralValue ? 1 : 0), separatorsNumbersSet(apartmentReceiptBalanceLocal, true).result),
                            status: setBadgeStatusGeneric({
                                type: apartmentReceiptBalanceLocal > neutralValue ? 1 : 0,
                                value: separatorsNumbersSet({
                                    number: apartmentReceiptBalanceLocal,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: currentMethod,
                                })?.result,
                            }),
                        };
                        //#endregion variables

                        //#region methods
                        $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                            dtRowObj?.receiptNumberApartment,
                            dtRowObj?.from,
                            dtRowObj?.total,
                            dtRowObj?.status,
                            buttonProcessGet({
                                id: apartmentReceiptLocal?.id,
                                description: apartment?.identifier,
                                showDetails: true,
                                labelDetails: labels?.receiptDetail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: false,
                                labelEdit: labels?.edit,
                                enabledEdit: false,
                                showDelete: false,
                                labelDelete: labels?.delete,
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ])?.draw(true);

                        apartmentBalanceLocal = numberSet({
                            number: apartmentBalance,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        apartmentBalanceTotalLocal = numberSet({
                            number: (apartmentBalanceLocal - conceptTotalLocal),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        setApartmentBalance(apartmentBalanceTotalLocal);
                        //#endregion methods
                        //#endregion update record dtReceipts

                        //#region update record dtApartments
                        //#region variables
                        dtRowObj = {
                            floor: apartment?.floor,
                            identifier: apartment?.identifier,
                            total: separatorsNumbersSet({
                                number: apartmentBalanceTotalLocal,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            }).result,
                        };
                        //#endregion variables

                        //#region methods
                        $(`#${dtApartmentsId}`)?.DataTable()?.row(dtApartmentsRowIndex)?.data?.([
                            dtRowObj?.floor,
                            dtRowObj?.identifier,
                            dtRowObj?.total,
                            buttonProcessGet({
                                id: apartment?.id,
                                description: apartment?.identifier,
                                showDetails: true,
                                labelDetails: labels?.viewReceipts?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: false,
                                labelEdit: labels?.edit,
                                enabledEdit: false,
                                showDelete: false,
                                labelDelete: labels?.delete,
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ])?.draw(true);
                        //#endregion methods
                        //#endregion update record dtApartments

                        //#region update building balance
                        buildingBalanceLocal = numberSet({
                            number: buildingBalance,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        buildingBalanceTotalLocal = numberSet({
                            number: (buildingBalanceLocal - conceptTotalLocal),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        setBuildingBalance(buildingBalanceTotalLocal);

                        response = await buildingBalanceSetAsync({
                            balance: buildingBalanceTotalLocal,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion update building balance

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        //#endregion apartmentReceiptDetail (delete)
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const receiptApartmentAddDetailGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptApartmentAddDetailGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region concepts get
            response = await conceptsGetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion concepts get

            setConceptAddShowModal(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentReceiptPrintAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentReceiptPrintAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            window?.open(`/${app?.reports?.receiptPrint}/${apartmentReceipt?.id}`, '_blank');

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion receipt (methods)

    //#region receipts (methods)
    const dataTableReceiptsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableReceiptsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtReceiptsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.number?.[languageObj?.id], width: '20%', },
                    { title: labels?.date?.[languageObj?.id], width: '25%', },
                    { title: labels?.total?.[languageObj?.id], className: 'text-right', width: '25%', },
                    { title: labels?.balance?.[languageObj?.id], className: 'text-right', width: '25%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtReceiptsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const receiptsGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'receiptsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let receiptsViewModelLocal = [receiptViewModelModelGet({})];
            let apartmentReceiptViewModel = apartmentReceiptViewModelModelGet({});
            //#endregion variables

            //#region variables initialize
            dtRows = [];
            setProcessType(-1);
            setDtApartmentsRowIndex(rowIndex);
            setApartmentBalance(neutralValue);
            //dtApartmentsRowIndexTwo = rowIndex;
            setReceipt(receiptModelGet({}));
            setReceiptPaymentPrintDisabled(true);
            setApartmentReceipt(apartmentReceiptModelGet({}));

            response = await dataTablesClearAsync({
                apartments: false,
                receipts: true,
                receipt: true,
                payments: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion variables initialize

            //#region apartment get
            apartmentReceiptViewModel = apartmentsReceiptsViewModel?.find(({ id: idLocal }) => idLocal === id) || {};
            setApartment(apartmentReceiptViewModel);
            //#endregion apartment get

            //#region receipts get
            if (processType === 0) {
                receiptsViewModelLocal = apartmentReceiptViewModel?.receipts;
            } else if (processType === 1) {
                receiptsViewModelLocal = apartmentReceiptViewModel?.receipts?.filter((a,) => a?.balance > 0);
            } else if (processType === 2) {
                receiptsViewModelLocal = apartmentReceiptViewModel?.receipts?.filter((a,) => a?.balance <= neutralValue);
            }
            //receiptsViewModelLocal = apartmentReceiptViewModel?.receipts?.sort((a, b) => a?.receiptNumber < b?.receiptNumber ? 1 : -1);
            receiptsViewModelLocal = receiptsViewModelLocal?.sort((a, b) => a?.receiptNumber < b?.receiptNumber ? 1 : -1);
            //#endregion receipts get

            //#region receipts in datatable data set
            if (!isUndNullEmp({ data: receiptsViewModelLocal, subMethod: currentMethod, })?.result && receiptsViewModelLocal?.length > 0) {
                setApartmentBalance(
                    numberSet({
                        number: lodash?.sum({
                            data: receiptsViewModelLocal,
                            key: dbProps?.balance,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result
                );

                for (let apartmentReceipt of receiptsViewModelLocal) {
                    dtRows.push([
                        apartmentReceipt?.receiptNumberApartment,
                        dateTimeFormatGlobalSet({
                            date: apartmentReceipt?.receipt?.from,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                        })?.result,
                        separatorsNumbersSet({
                            number: apartmentReceipt?.total,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        setBadgeStatusGeneric({
                            type: apartmentReceipt?.balance > neutralValue ? 1 : 0,
                            value: separatorsNumbersSet({
                                number: apartmentReceipt?.balance,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result
                        }),
                        buttonProcessGet({
                            id: apartmentReceipt?.id,
                            description: description,
                            showDetails: true,
                            labelDetails: labels?.receiptDetail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: false,
                            labelEdit: labels?.edit,
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: labels?.delete,
                            enabledDelete: false,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                }
            }

            $(`#${dtReceiptsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //setDtApartmentsRowIndex(rowIndex);
            //dtApartmentsRowIndexTwo = rowIndex;

            if (processType === 0 && !$(`#${radioReceiptBalanceOneId}`)?.checked) {
                $(`#${radioReceiptBalanceOneId}`)?.prop('checked', true);
            }
            //#endregion receipts in datatable data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion receipts (methods)

    //#region payments (methods)
    const dataTablePaymentsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablePaymentsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPaymentsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.date?.[languageObj?.id], orderable: false, searchable: false, visible: false, width: '0%', },
                    { title: labels?.type?.[languageObj?.id], width: '55%', },
                    { title: labels?.date?.[languageObj?.id], width: '20%', },
                    { title: labels?.amount?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtPaymentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const paymentAddGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'paymentAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region check if apartment receipt is different zero
            if (isUndNullEmp({ data: apartmentReceipt?.balance, subMethod: currentMethod, })?.result || apartmentReceipt?.balance <= neutralValue) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToRecordsWithBalanceGreaterThanZero?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion check if apartment receipt is different zero

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            //#region get payment method (data)
            response = await paymentsDataGetAsync({
                buildingId: buildingIdLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.thisProcessAppliesOnlyToRecordsWithBalanceGreaterThanZero?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion get payment method (data)

            //#region payment set
            setApartmentReceiptPayment(
                apartmentReceiptPaymentModelGet({
                    buildingId: apartmentReceipt?.buildingId,
                    apartmentId: apartmentReceipt?.apartmentId,
                    receiptId: apartmentReceipt?.receiptId,
                    apartmentReceiptId: apartmentReceipt?.id,
                    paymentMethodId: '',
                    bankId: '',
                    bankOriginId: '',
                    bankAccountId: '',
                    userId: auth?.user?.uid
                })
            );
            setProcessType(0);
            //#endregion payment set

            setPaymentShowModal(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const apartmentReceiptPaymentByIdGetAsync = async ({
        id = '',
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptPaymentByIdGetAsync';
        let response = responseGet();
        try {
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const paymentEditDetailsGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'paymentEditDetailsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            let apartmentReceiptPaymentLocal = apartmentReceiptPaymentModelGet({});
            //#endregion variables

            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: true, });

            //#region apartmentReceiptPayment get
            response = await apartmentReceiptPaymentByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceiptPaymentLocal = response?.result || {};
            setApartmentReceiptPayment(apartmentReceiptPaymentLocal);
            //#endregion apartmentReceiptPayment get

            //#region check payment
            if (processType === 1 && isUndNullEmp({ data: apartmentReceiptPaymentLocal?.id, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                response.msgText = `${messages?.theRecordCannotBeLocated.en}<br/>`;
                response.msgText += `${labels?.reference?.[languageObj?.id]}: <b>${description}</b><br/>`;
                response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (apartmentReceiptPaymentLocal?.concilationStatus === 'S' && processType === 1) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                response.msgText = `${messages?.thisProcessOnlyAppliesUnreconciledRecords?.[languageObj?.id]}<br/>`;
                response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion check payment

            //#region paymentMethod get
            response = await paymentsDataGetAsync({
                buildingId: buildingIdLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion get payment method (data)

            //#region data set
            setProcessType(processType);
            setDtPaymentsRowIndex(rowIndex);
            //dtPaymentsRowIndexTwo = rowIndex;
            //#endregion data set

            setPaymentShowModal(true);

            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const paymentDeleteAsync = async (id = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         //#region variables

    //         let localPayment = {};
    //         let localPaymentMethod = {};

    //         //#endregion variables

    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region get payment

    //         response = await apartmentReceiptPaymentByIdGetAsync(id);
    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return;
    //         }
    //         localPayment = response.result;
    //         setPayment(localPayment);
    //         setDtPaymentsRowIndex(rowIndex);
    //         dtPaymentsRowIndexTwo = rowIndex

    //         //#endregion get payment

    //         //#region payment methods get

    //         localPaymentMethod = paymentMethodsTwo.filter(({ id }) => id === localPayment.paymentMethodId)[0];

    //         //#endregion payment methods get

    //         //#region show message for delete

    //         response.msgText = `${labels?.paymentMethod?.[languageObj?.id]}: <b>${localPaymentMethod.description}</b><br/>`;
    //         response.msgText += `${labels?.reference?.[languageObj?.id]}: <b>${description}</b><br/>`;
    //         response.msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: response.msgText,
    //             timer: null,
    //             confirmButtonColor: colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         if (isConfirmed) {
    //             $(`#${btnPaymentDeleteId}`)?.trigger('click');
    //         }

    //         //#endregion show message for delete
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: paymentDeleteAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    //     return response;
    // }
    //#endregion old code

    //#region old code
    // const localPaymentDeletePost = (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();
    //         paymentDeleteAsync();
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localPaymentDeletePost<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    //     return response;
    // }
    //#endregion old code

    const paymentDeleteAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'paymentDeleteAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let balanceLocal = neutralValue;
            let apartmentBalanceLocal = neutralValue;
            let buildingBalanceTotalLocal = neutralValue;
            let apartmentReceiptLocal = apartmentReceiptModelGet({});
            let apartmentReceiptPaymentLocal = apartmentReceiptPaymentModelGet({});
            //#endregion variables

            //#region message
            let msgTextObj = {
                one: `${labels?.paymentMethod?.[languageObj?.id]}: <b>${objFind?.description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region apartmentReceiptPayment delete
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageCode: languageObj?.code,
                                languageId: languageObj?.id,
                            },
                            url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/${objFind?.id}`
                        };

                        result = await axios?.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        apartmentReceiptLocal = response?.result?.apartmentReceipt || {};
                        apartmentReceiptPaymentLocal = response?.result?.apartmentReceiptPayment || {};
                        setApartmentReceipt(apartmentReceiptLocal);
                        //#endregion apartmentreceiptPayment delete

                        //#region update payment (total)
                        setTotalPayments(
                            numberSet({
                                number: (totalPayments - apartmentReceiptPaymentLocal?.amount),
                                type: 'd',
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result
                        );
                        //#endregion update payment (total)

                        //#region remove payments (dtPayments)
                        $(`#${dtPaymentsId}`)?.DataTable()?.row(objFind?.rowIndex)?.remove()?.draw(true);
                        //#endregion Remove payments (dtPayments)

                        //#region update receipts (dtReceipts)
                        //#region variables
                        dtRowObj = {
                            receiptNumberApartment: apartmentReceiptLocal?.receiptNumberApartment,
                            from: dateTimeFormatGlobalSet({
                                date: receipt?.from,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            total: separatorsNumbersSet({
                                number: apartmentReceiptLocal?.total,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                            status: setBadgeStatusGeneric({
                                type: apartmentReceiptLocal?.balance > neutralValue ? 1 : 0,
                                value: separatorsNumbersSet({
                                    number: apartmentReceiptLocal?.balance,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: currentMethod,
                                })?.result
                            }),
                        };
                        //#endregion variables

                        //#region methods
                        $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                            //#region old code
                            // apartmentReceiptLocal.receiptNumberApartment,
                            // dateTimeFormatGlobalSet(receipt.from, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            // separatorsNumbersSet(apartmentReceiptLocal.total, true).result,
                            // setBadgeStatusGeneric((apartmentReceiptLocal.balance > neutralValue ? 1 : 0), separatorsNumbersSet(apartmentReceiptLocal.balance, true).result),
                            //#endregion old code
                            dtRowObj?.receiptNumberApartment,
                            dtRowObj?.from,
                            dtRowObj?.total,
                            dtRowObj?.status,
                            buttonProcessGet({
                                id: apartmentReceiptLocal?.id,
                                description: apartment?.identifier,
                                showDetails: true,
                                labelDetails: labels?.receiptDetail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: false,
                                labelEdit: labels?.edit,
                                enabledEdit: false,
                                showDelete: false,
                                labelDelete: labels?.delete,
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ])?.draw(true);
                        //#endregion methods
                        balanceLocal = numberSet({
                            number: apartmentBalance,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        apartmentBalanceLocal = numberSet({
                            number: (balanceLocal + apartmentReceiptPaymentLocal?.amount),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        setApartmentBalance(apartmentBalanceLocal);
                        //#endregion update receipts (dtReceipts)

                        //#region update apartments (dtApartmets)
                        //#region variables
                        dtRowObj = {
                            floor: apartment?.floor,
                            identifier: apartment?.identifier,
                            balance: separatorsNumbersSet({
                                number: apartmentBalanceLocal,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result,
                        };
                        //#endregion variables

                        //#region methods
                        $(`#${dtApartmentsId}`)?.DataTable()?.row(dtApartmentsRowIndex)?.data?.([
                            //#region old code
                            // apartment.floor,
                            // apartment.identifier,
                            // separatorsNumbersSet(apartmentBalanceLocal, true).result,
                            //#endregion old code
                            dtRowObj?.floor,
                            dtRowObj?.identifier,
                            dtRowObj?.balance,
                            buttonProcessGet({
                                id: apartment?.id,
                                description: apartment?.identifier,
                                showDetails: true,
                                labelDetails: labels?.viewReceipts?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: false,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: false,
                                showDelete: false,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            }).result,
                        ])?.draw(true);
                        //#endregion methods
                        //#endregion update apartments (dtApartmets)

                        //#region update building balance
                        balanceLocal = numberSet({
                            number: buildingBalance,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;
                        buildingBalanceTotalLocal = numberSet({
                            number: (balanceLocal + apartmentReceiptPaymentLocal?.amount),
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result;

                        response = await buildingBalanceSetAsync({
                            balance: buildingBalanceTotalLocal,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            return response;
                        }

                        setBuildingBalance(buildingBalanceTotalLocal);
                        //#endregion update building balance

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion message

            //#region old code
            // sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            // //#region delete payment

            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // //result = await axios.delete(`${app?.backend?.urlDev}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/${payment.id}`, headerObj);
            // result = await axios.delete(`${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/${payment.id}`, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // localAR = response?.result?.apartmentReceipt;
            // localARP = response?.result?.apartmentReceiptPayment;
            // setApartmentReceipt(localAR);

            // //#endregion delete payment

            // //#region update payment (total)

            // setTotalPayments(numberSet((totalPayments - localARP.amount), 'd').result);

            // //#endregion update payment (total)

            // //#region remove payments (dtPayments)

            // $(`#${dtPaymentsId}`)?.DataTable()?.row(dtPaymentsRowIndex)?.remove()?.draw(true);

            // //#endregion Remove payments (dtPayments)

            // //#region update receipts (dtReceipts)

            // $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
            //     localAR.receiptNumberApartment,
            //     dateTimeFormatGlobalSet(receipt.from, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
            //     separatorsNumbersSet(localAR.total, true).result,
            //     setBadgeStatusGeneric((localAR.balance > neutralValue ? 1 : 0), separatorsNumbersSet(localAR.balance, true).result),
            //     buttonProcessGet(
            //         localAR.id,
            //         apartment.identifier,
            //         true,
            //         labels?.receiptDetail?.[languageObj?.id],
            //         true,
            //         false,
            //         labels?.edit,
            //         false,
            //         false,
            //         labels?.delete,
            //         false,
            //         []
            //     ).result,
            // ])?.draw(true);

            // localBalance = numberSet(apartmentBalance, 'd').result;
            // localApartmentBalance = numberSet((localBalance + localARP.amount), 'd').result;
            // setApartmentBalance(localApartmentBalance);

            // //#endregion update receipts (dtReceipts)

            // //#region update apartments (dtApartmets)

            // $(`#${dtApartmentsId}`)?.DataTable()?.row(dtApartmentsRowIndex)?.data?.([
            //     apartment.floor,
            //     apartment.identifier,
            //     separatorsNumbersSet(localApartmentBalance, true).result,
            //     buttonProcessGet(
            //         apartment.id,
            //         apartment.identifier,
            //         true,
            //         labels?.viewReceipts?.[languageObj?.id],
            //         true,
            //         false,
            //         labels?.edit?.[languageObj?.id],
            //         false,
            //         false,
            //         labels?.delete?.[languageObj?.id],
            //         false,
            //         []
            //     ).result,
            // ])?.draw(true);

            // //#endregion update apartments (dtApartmets)

            // //#region update building balance

            // localBalance = numberSet(buildingBalance, 'd').result;
            // localBuildingBalanceTotal = numberSet((localBalance + localARP.amount), 'd').result;
            // //setBuildingBalance(localBuildingBalanceTotal);

            // response = buildingBalanceSetAsync(
            //     localBuildingBalanceTotal,
            //     'paymentDeleteAsync'
            // );

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return response;
            // }

            // setBuildingBalance(localBuildingBalanceTotal);

            // //#endregion update building balance

            // sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            //#endregion old code
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentPaymentFiles = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentPaymentFiles';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.response) {
                e?.preventDefault();
            }

            //#region variables
            let apartmentReceiptPaymentLocal = {
                ...apartmentReceiptPaymentModelGet({}),
                process: process,
            };
            let apartmentReceiptPaymentFilesLocal = {
                ...apartmentReceiptPaymentFileModelGet({}),
                process: process,
            };
            //#endregion variables

            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: true, });

            //#region data get (apartment receipt payment)
            response = await apartmentReceiptPaymentByIdGetAsync({
                id: objFind?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceiptPaymentLocal = response?.result || {};
            setApartmentReceiptPayment(apartmentReceiptPaymentLocal);
            //#endregion data get (apartment receipt payment)

            //#region data get (apartment receipt payment file)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                limit: 0,
                ordersBy: [],
                conditionals: [
                    { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: apartmentReceipt?.buildingId, },
                    { field: dbProps?.apartmentId, operator: dbOpera?.equalTo, value: apartmentReceipt?.apartmentId, },
                    { field: dbProps?.receiptId, operator: dbOpera?.equalTo, value: apartmentReceipt?.receiptId, },
                    { field: dbProps?.apartmentReceiptId, operator: dbOpera?.equalTo, value: apartmentReceipt?.id, },
                    { field: dbProps?.apartmentReceiptPaymentId, operator: dbOpera?.equalTo, value: objFind?.id, },
                ],
                buildingId: apartmentReceipt?.buildingId,
                apartmentId: apartmentReceipt?.apartmentId,
                languageId: languageObj?.id,
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPaymentFiles}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceiptPaymentFilesLocal = response?.result || [];
            //#endregion data get (apartment receipt payment file)

            //#region data load 
            if (!isUndNullEmp({ data: apartmentReceiptPaymentFilesLocal, subMethod: currentMethod, })?.result && apartmentReceiptPaymentFilesLocal?.length > 0) {
                setApartmentReceiptPaymentFile(apartmentReceiptPaymentFilesLocal?.[0]);
            } else {
                //#region create data (apartement receipt payment file)
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    apartmentReceiptPaymentFile: {
                        ...apartmentReceiptPaymentFile,
                        buildingId: apartmentReceipt?.buildingId,
                        apartmentId: apartmentReceipt?.apartmentId,
                        receiptId: apartmentReceipt?.receiptId,
                        apartmentReceiptId: apartmentReceipt?.id,
                        apartmentReceiptPaymentId: objFind?.id,
                        userId: auth?.user?.uid,
                    },
                    languageId: languageObj?.id,
                    url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPaymentFiles}/`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data || {};

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                apartmentReceiptPaymentFilesLocal = response?.result?.apartmentReceiptPaymentFile || {};
                setApartmentReceiptPaymentFile(apartmentReceiptPaymentFilesLocal);
                //#endregion create data (apartment receipt payment file)
            }
            //#endregion data load

            setApartmentReceiptPaymentFileShowModal(true);
            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion payments (methods)

    //#region concepts (methods)
    const conceptsGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'conceptsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let checkBoxLocal = '';
            let conceptsLocal = [conceptModelGet({})];
            //#endregion variables

            //#region initialize
            setConcepts([]);
            setConceptsDt([]);
            conceptsLocal = [];
            //#endregion initialize

            //#region data get (expense concepts)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                ordersBy: [
                    { field: dbProps?.description, value: 'asc' },
                ],
                conditionals: [
                    { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: receipt?.buildingId, },
                ],
                buildingId: receipt?.buildingId,
                languageId: languageObj?.id,
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlExpenseConcepts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            conceptsLocal = response?.result || [];
            //#endregion data get (expense concepts)

            //#region data load
            if (!isUndNullEmp({ data: expenseTemplate?.details, subMethod: currentMethod, })?.result && expenseTemplate?.details?.length > 0) {
                expenseTemplate?.details?.forEach((detail) => {
                    conceptsLocal = conceptsLocal?.filter(({ id, }) => id !== detail?.id);
                });
            }

            if (!isUndNullEmp({ data: apartmentReceiptDetails, subMethod: currentMethod, })?.result && apartmentReceiptDetails?.length > 0) {
                apartmentReceiptDetails?.forEach((detail) => {
                    conceptsLocal = conceptsLocal?.filter(({ id, }) => id !== detail?.expenseConceptId);
                })
            }

            conceptsLocal?.forEach((detail) => {
                checkBoxLocal = `<div class='custom-control custom-radio' for='${detail?.id}'>`;
                checkBoxLocal += `  <input class='custom-control-input' type='radio' name='conceptAdd' description='${detail?.description}' id='${detail?.id}' />`;
                checkBoxLocal += `  <label class='custom-control-label' for='${detail?.id}'></label>`
                checkBoxLocal += `</div>`
                dtRows.push([
                    detail?.description,
                    checkBoxLocal,
                ]);
            });
            setConcepts(conceptsLocal);
            setConceptsDt(dtRows);
            //#endregion data load

            //#region final data set
            response.result = {
                concepts: conceptsLocal,
                conceptsDt: dtRows,
            };
            //#endregion final data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion concepts (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, apartments: true, receipts: true, receipt: true, payments: true, });

            //#region dataTable set
            response = await dataTablesSetAsync({
                apartments: true,
                receipts: true,
                receipt: true,
                payments: true,
                queryCodeSet: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                return
            }
            //#endregion dataTable set

            //#region initialize
            response = await buildingBalanceSetAsync({
                balance: neutralValue,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                return;
            }

            setApartmentsReceiptsViewModel([]);
            //#endregion initialize

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: app?.backend?.urlHome,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, apartments: false, receipts: false, receipt: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let dt = {};
            //let idRows = [];
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region apartments
            $(`#${dtApartmentsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                dt = $(`#${dtApartmentsId}`)?.DataTable();
                rowIndex = dt?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            setObjFind({ id: id, description: description, rowIndex: dtRowIndex, processType: 0, subMethod: currentMethod, });
                            $(`#${controls?.buttons?.apartmentReceiptsFind?.id}`)?.trigger('click');
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion apartments

            //#region receipts
            $(`#${dtReceiptsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                dt = $(`#${dtReceiptsId}`)?.DataTable();
                rowIndex = dt?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            setObjFind({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, })
                            $(`#${controls?.buttons?.apartmentReceiptDetailFind?.id}`)?.trigger('click');
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion receipts

            //#region receipt
            $(`#${dtReceiptId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                dt = $(`#${dtReceiptId}`)?.DataTable();
                rowIndex = dt?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            apartmentReceiptDetailEditGetAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            setObjFind({ id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            $(`#${controls?.buttons?.apartmentReceiptDetailDelete?.id}`)?.trigger('click');
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion receipt

            //#region payments
            $(`#${dtPaymentsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                dt = $(`#${dtPaymentsId}`)?.DataTable();
                rowIndex = dt?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            paymentEditDetailsGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            paymentEditDetailsGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            setObjFind({ id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            $(`#${controls?.buttons?.apartmentReceiptPaymentDelete?.id}`)?.trigger('click');
                            break;
                        case 'attachedFiles':
                            dtHighLightingClassSet({ dt: dt, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            setObjFind({ id: id, description: description, rowIndex: dtRowIndex, processType: 3, subMethod: currentMethod, });
                            $(`#${controls?.buttons?.apartmentReceiptPaymentAttachmentFiles?.id}`)?.trigger('click');
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion payments

            //#region apartements (balance)
            $(`#${radioBuildingBalanceOneId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${controls?.buttons?.apartmemtsFind?.id}`)?.trigger('click');
                }
            });

            $(`#${radioBuildingBalanceTwoId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${controls?.buttons?.apartmentsGreaterThatZeroFind?.id}`)?.trigger('click');
                }
            });

            $(`#${radioBuildingBalanceThreeId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${controls?.buttons?.apartmentsLessThatZeroFind?.id}`)?.trigger('click');
                }
            });
            //#endregion apartements (balance)

            //#region receipts (balance)
            $(`#${radioReceiptBalanceOneId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${controls?.buttons?.apartmentReceiptsAllFind?.id}`)?.trigger('click');
                }
            });

            $(`#${radioReceiptBalanceTwoId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${controls?.buttons?.apartmentReceiptsGreaterThatZeroFind?.id}`)?.trigger('click');
                }
            });

            $(`#${radioReceiptBalanceThreeId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${controls?.buttons?.apartmentReceiptsLessThatZeroFind?.id}`)?.trigger('click');
                }
            });
            //#endregion receipts (balance)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dtHighLightingClassSet = ({
        dt = {},
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'dtHighLightingClassSet';
        let response = responseGet();
        try {
            //#region variables
            let idRows = [];
            //#endregion variables

            //#region methods
            idRows = dt?.rows(`.${classNameHighLightingLocal?.replaceAll(' ', '.')}`);
            idRows?.[0]?.forEach((rowId) => {
                $(dt?.row(rowId)?.node())?.removeClass(classNameHighLightingLocal);
            });
            $(dt?.row(rowIndex)?.node())?.addClass(classNameHighLightingLocal);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(responseGet);
        }
    }

    const dataTablesClearAsync = async ({
        apartments = false,
        receipts = false,
        receipt = false,
        payments = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesClearAsync';
        let response = responseGet();
        try {
            if (apartments) {
                $(`#${dtApartmentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }

            if (receipts) {
                $(`#${dtReceiptsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }

            if (receipt) {
                $(`#${dtReceiptId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }

            if (payments) {
                $(`#${dtPaymentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response
    }

    const dataTablesSetAsync = async ({
        apartments = false,
        receipts = false,
        receipt = false,
        payments = false,
        queryCodeSet = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            //#region methods
            if (apartments) {
                response = await dataTableApartmentsSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (receipts) {
                response = await dataTableReceiptsSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (receipt) {
                response = await dataTableReceiptSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (payments) {
                response = await dataTablePaymentsSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (queryCodeSet) {
                response = await queryCodeSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const paymentsDataGetAsync = async ({
        buildingId = '',
        subMethod = '',
    }) => {
        const currentMethod = 'paymentsDataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#endregion variables

            //#region banks get
            response = await validationBankGetAsync({
                buildingId: buildingId,
                auth: auth,
                limit: 0,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            banksTwo = response?.result || [];
            setBanks(banksTwo);
            //#endregion banks get

            //#region data get (payment methods)
            response = await validationPaymentMethodGetAsync({
                buildingId: buildingId,
                auth: auth,
                limit: 0,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            paymentMethodsTwo = response?.result || [];
            setPaymentMethods(paymentMethodsTwo);
            //#endregion data get (payment methods)

            //#region data get (bank accounts)
            response = await validationBankAccountGetAsync({
                buildingId: buildingId,
                auth: auth,
                limit: 0,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            bankAccountsTwo = response?.result || [];
            setBankAccounts(bankAccountsTwo);

            let banksDestintyLocal = [];
            const bankAccountsUniqLocal = lodash?.unique({
                data: bankAccountsTwo,
                key: dbProps?.bankId,
                subMethod: currentMethod,
            })?.result;

            bankAccountsUniqLocal?.forEach((detail) => {
                banksDestintyLocal?.push(
                    banksTwo?.find(({ id }) => id === detail?.bankId)
                );
            });

            setBanksDestiny(banksDestintyLocal);
            //#endregion data get (bank accounts)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.apartmentReceiptDetailAdd?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.apartmentReceiptDetailAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.apartmentReceiptPrint?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.apartmentReceiptPrint?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.apartmentReceiptPaymentAdd?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.apartmentReceiptPaymentAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0 && processType >= 3));
            // $(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0 && processType >= 3));
            // $(`#${controls?.inputs?.expenseTemplateTotal?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));

            $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', processType !== 0);
            $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', processType !== 0);

            $(`#${controls?.dataTables?.apartmentReceipts?.inputs?.search?.id}`)?.attr('readOnly', processType !== 0);
            $(`#${controls?.dataTables?.apartmentReceipts?.selects?.entries?.id}`)?.attr('disabled', processType !== 0);

            $(`#${controls?.dataTables?.apartmentReceiptDetails?.inputs?.search?.id}`)?.attr('readOnly', processType !== 0);
            $(`#${controls?.dataTables?.apartmentReceiptDetails?.selects?.entries?.id}`)?.attr('disabled', processType !== 0);

            $(`#${controls?.dataTables?.apartmentReceiptPayments?.inputs?.search?.id}`)?.attr('readOnly', processType !== 0);
            $(`#${controls?.dataTables?.apartmentReceiptPayments?.selects?.entries?.id}`)?.attr('disabled', processType !== 0);

            // $(`#${controls?.dataTables?.expenseConcepts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType >= 3));
            // $(`#${controls?.dataTables?.expenseConcepts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType >= 3));
            //#endregion dataTable

            if (processType !== 0) {
                // if (processType <= 2) {
                //     $(`#${controls?.buttons?.detailAdd?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                //     $(`#${controls?.buttons?.apartmentReceiptPrint?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                // } else if (processType >= 3) {
                //     $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                //     $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                //     $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                // }
                $(`#${controls?.buttons?.apartmentReceiptDetailAdd?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.apartmentReceiptPrint?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.apartmentReceiptPaymentAdd?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
        //console?.log(0);
    }, [auth]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='receipts' process='generated' />

            <div className='content-wrapper'>
                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.receiptGenerateds?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.receiptGenerateds?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnReceiptsSyncDisabled}
                            methodGetAsync={apartmentsGetAsync}
                            processType={0}
                            headerSectionValues={headerSectionValues}
                            showLoading={showLoading?.building}
                            languageObj={languageObj} />

                        <div className='row'>
                            {/*apartments*/}
                            <div className='col-md-6'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.apartments}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.apartments?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.apartmentsLogo}></img> - {labels?.apartments?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className={buildingBalance === neutralValue ?
                                                            fromControls?.bgTransparentIsValidTextBlackTextRight :
                                                            fromControls?.bgTransparentIsWarningTextBlackTextRight}
                                                            placeholder={labels?.balance?.[languageObj?.id]}
                                                            //onFocus={() => setBuildingContractError('')}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.balance?.[languageObj?.id]}
                                                            value={
                                                                separatorsNumbersSet({
                                                                    number: buildingBalance || neutralValue,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: currentMethod,
                                                                })?.result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <label>{labels?.balance?.[languageObj?.id]}:</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio'
                                                            disabled={isUndNullEmp({ data: building?.id, subMethod: 'radio - all', })?.result}
                                                            id={radioBuildingBalanceOneId}
                                                            name={radioBuildingBalanceName} />
                                                        <label htmlFor={radioBuildingBalanceOneId}>{labels?.all?.[languageObj?.id]}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio'
                                                            disabled={isUndNullEmp({ data: building?.id, subMethod: 'radio - higher', })?.result}
                                                            id={radioBuildingBalanceTwoId}
                                                            name={radioBuildingBalanceName} />
                                                        <label htmlFor={radioBuildingBalanceTwoId}>{labels?.higher} {
                                                            separatorsNumbersSet({
                                                                number: neutralValue,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'radio - higher',
                                                            })?.result
                                                        }</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio'
                                                            disabled={isUndNullEmp({ data: building?.id, subMethod: 'radio - equal', })?.result}
                                                            id={radioBuildingBalanceThreeId}
                                                            name={radioBuildingBalanceName} />
                                                        <label htmlFor={radioBuildingBalanceThreeId}>{labels?.equal} {
                                                            separatorsNumbersSet({
                                                                number: neutralValue,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'radio - equal',
                                                            })?.result
                                                        }</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'
                                            hidden={true}>
                                            <div className='form-group text-right'>
                                                <button id={controls?.buttons?.apartmemtsFind?.id}
                                                    className={controls?.buttons?.apartmemtsFind?.className}
                                                    disabled={
                                                        isUndNullEmp({ data: building?.id, subMethod: 'btn - apartmentsAllGet', })?.result
                                                    }
                                                    onClick={(e) => apartmentsGetAsync({
                                                        e: e, processType: 0,
                                                        subMethod: 'btn - apartmentsAllGet',
                                                    })}
                                                    type='button'>
                                                    <i id={controls?.icons?.apartmentsFind?.id} className={controls?.icons?.apartmentsFind?.className} /> <span id={controls?.spinners?.apartmentsFind?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.apartmentsGreaterThatZeroFind?.id}
                                                    className={controls?.buttons?.apartmentsGreaterThatZeroFind?.className}
                                                    disabled={
                                                        isUndNullEmp({ data: building?.id, subMethod: 'btn - apartmentsGreaterThatZeroFind', })?.result
                                                    }
                                                    onClick={(e) => apartmentsGetAsync({
                                                        e: e,
                                                        processType: 1,
                                                        subMethod: 'btn - apartmentsGreaterThatZeroFind',
                                                    })}
                                                    type='button'>
                                                    <i id={controls?.icons?.apartmentsGreaterThatZeroFind?.id} className={controls?.icons?.apartmentsGreaterThatZeroFind?.className} /> <span id={controls?.spinners?.apartmentsGreaterThatZeroFind?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.apartmentsLessThatZeroFind?.id}
                                                    className={controls?.buttons?.apartmentsLessThatZeroFind?.className}
                                                    disabled={
                                                        isUndNullEmp({ data: building?.id, subMethod: 'btn - apartmentsLessThatZeroFind', })?.result
                                                    }
                                                    onClick={(e) => apartmentsGetAsync({
                                                        e: e,
                                                        processType: 2,
                                                        subMethod: 'btn - apartmentsLessThatZeroFind',
                                                    })}
                                                    type='button'>
                                                    <i id={controls?.icons?.apartmentsLessThatZeroFind?.id} className={controls?.icons?.apartmentsLessThatZeroFind?.className} /> <span id={controls?.spinners?.apartmentsLessThatZeroFind?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtApartmentsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                            </div>{/*col*/}

                            {/*receipts*/}
                            <div className='col-md-6'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.receipts}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.receipts?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.receiptsLogo}></img> - {labels?.receipts?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className='form-control bg-transparent text-black'
                                                            placeholder={labels?.apartment?.[languageObj?.id]}
                                                            //onFocus={() => setBuildingContractError('')}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.apartment?.[languageObj?.id]}
                                                            value={apartment?.identifier || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className='fas fa-house-user' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className={apartmentBalance === neutralValue ?
                                                            fromControls?.bgTransparentIsValidTextBlackTextRight :
                                                            fromControls?.bgTransparentIsWarningTextBlackTextRight}
                                                            placeholder={labels?.balance?.[languageObj?.id]}
                                                            //onFocus={() => setBuildingContractError('')}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.balance?.[languageObj?.id]}
                                                            value={
                                                                separatorsNumbersSet({
                                                                    number: apartmentBalance || neutralValue,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - balance',
                                                                })?.result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='form-group'>
                                                <ul className='list-unstyled text-muted'>
                                                    <li>{labels?.legend?.[languageObj?.id]}: {HtmlParser(setBadgeStatusGeneric({ type: 1, value: labels?.pending?.[languageObj?.id], subMethod: 'li - pending', }))} {HtmlParser(setBadgeStatusGeneric({ type: 0, value: labels?.paidOut?.[languageObj?.id], subMethod: 'li - paidOut', }))}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <label>{labels?.balance?.[languageObj?.id]}:</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio'
                                                            //disabled={isUndefined(apartment) || isUndefined(apartment.id)} 
                                                            disabled={isUndNullEmp({ data: apartment?.id, subMethod: 'radio - apartmentAll', })?.result}
                                                            id={radioReceiptBalanceOneId}
                                                            name={radioReceiptBalanceName} />
                                                        <label htmlFor={radioReceiptBalanceOneId}>{labels?.all?.[languageObj?.id]}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio'
                                                            //disabled={isUndefined(apartment) || isUndefined(apartment.id)} 
                                                            disabled={isUndNullEmp({ data: apartment?.id, subMethod: 'radio - apartmentHigHer', })?.result}
                                                            id={radioReceiptBalanceTwoId}
                                                            name={radioReceiptBalanceName} />
                                                        <label htmlFor={radioReceiptBalanceTwoId}>{labels?.higher} {
                                                            separatorsNumbersSet({
                                                                number: neutralValue,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'radio - apartmentHigher',
                                                            })?.result
                                                        }</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio'
                                                            //disabled={isUndefined(apartment) || isUndefined(apartment.id)} 
                                                            disabled={isUndNullEmp({ data: apartment?.id, subMethod: 'radio - apartmentEqual', })?.result}
                                                            id={radioReceiptBalanceThreeId}
                                                            name={radioReceiptBalanceName} />
                                                        <label htmlFor={radioReceiptBalanceThreeId}>{labels?.equal} {
                                                            separatorsNumbersSet({
                                                                number: neutralValue,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'radio - apartmentEqual',
                                                            })?.result
                                                        }</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'
                                            hidden={true} >
                                            <div className='form-group text-right'>
                                                <button id={controls?.buttons?.apartmentReceiptsFind?.id}
                                                    className={controls?.buttons?.apartmentReceiptsFind?.className}
                                                    disabled={
                                                        isUndNullEmp({ data: building?.id, subMethod: 'btn - receiptsFind', })?.result
                                                    }
                                                    onClick={() => receiptsGetAsync({
                                                        id: objFind?.id,
                                                        description: objFind?.description,
                                                        rowIndex: objFind?.rowIndex,
                                                        processType: 0,
                                                        subMethod: 'btn - receiptsFind',
                                                    })}
                                                    type='button'>
                                                    <i id={controls?.icons?.apartmentReceiptsFind?.id} className={controls?.icons?.apartmentReceiptsFind?.className} /> <span id={controls?.spinners?.apartmentReceiptsFind?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.apartmentReceiptsAllFind?.id}
                                                    className={controls?.buttons?.apartmentReceiptsAllFind?.className}
                                                    disabled={
                                                        isUndNullEmp({ data: apartment?.id, subMethod: 'btn - apartmentReceiptsAll', })?.result
                                                    }
                                                    onClick={() => receiptsGetAsync({
                                                        id: apartment?.id,
                                                        description: apartment?.identifier,
                                                        rowIndex: dtApartmentsRowIndex,
                                                        processType: 0,
                                                        subMethod: 'btn - apartmentReceiptsAll',
                                                    })}
                                                    type='button'>
                                                    <i id={controls?.icons?.apartmentReceiptsAllFind?.id} className={controls?.icons?.apartmentReceiptsAllFind?.className} /> <span id={controls?.spinners?.apartmentReceiptsAllFind?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.apartmentReceiptsGreaterThatZeroFind?.id}
                                                    className={controls?.buttons?.apartmentReceiptsGreaterThatZeroFind?.className}
                                                    disabled={
                                                        isUndNullEmp({ data: apartment?.id, subMethod: 'btn - apartmentReceiptsGreaterThatZeroFind', })?.result
                                                    }
                                                    onClick={() => receiptsGetAsync({
                                                        id: apartment?.id,
                                                        description: apartment?.identifier,
                                                        rowIndex: dtApartmentsRowIndex,
                                                        processType: 1,
                                                        subMethod: 'btn - apartmentReceiptsGreaterThatZeroFind',
                                                    })}
                                                    type='button'>
                                                    <i id={controls?.icons?.apartmentReceiptsGreaterThatZeroFind?.id} className={controls?.icons?.apartmentReceiptsGreaterThatZeroFind?.className} /> <span id={controls?.spinners?.apartmentReceiptsGreaterThatZeroFind?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.apartmentReceiptsLessThatZeroFind?.id}
                                                    className={controls?.buttons?.apartmentReceiptsLessThatZeroFind?.className}
                                                    disabled={
                                                        isUndNullEmp({ data: apartment?.id, subMethod: 'btn - apartmentReceiptsLessThatZeroFind', })?.result
                                                    }
                                                    onClick={() => receiptsGetAsync({
                                                        id: apartment?.id,
                                                        description: apartment?.identifier,
                                                        rowIndex: dtApartmentsRowIndex,
                                                        processType: 2,
                                                        subMethod: 'btn - apartmentReceiptsLessThatZeroFind',
                                                    })}
                                                    type='button'>
                                                    {/* <i className={icons?.sortNumericDown}></i> */}
                                                    <i id={controls?.icons?.apartmentReceiptsLessThatZeroFind?.id} className={controls?.icons?.apartmentReceiptsLessThatZeroFind?.className} /> <span id={controls?.spinners?.apartmentReceiptsLessThatZeroFind?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtReceiptsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}
                            </div>{/*col*/}
                        </div>{/*row*/}

                        <div className='row'>
                            {/*receipt (details)*/}
                            <div className='col-md-6'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.receipt}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.receipt?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.receiptLogo}></img> - {labels?.receipt?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className='form-control bg-transparent text-black'
                                                            placeholder={labels?.apartment?.[languageObj?.id]}
                                                            //onFocus={() => setBuildingContractError('')}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.apartment?.[languageObj?.id]}
                                                            value={apartment?.identifier || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className='fas fa-house-user' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className={'form-control bg-transparent text-black text-right'}
                                                            placeholder={labels?.receipt?.[languageObj?.id]}
                                                            //onFocus={() => setBuildingContractError('')}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.receipt?.[languageObj?.id]}
                                                            value={apartmentReceipt?.receiptNumberApartment || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.receipt} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className='form-control bg-transparent text-black text-right'
                                                            placeholder={labels?.total?.[languageObj?.id]}
                                                            //onFocus={() => setBuildingContractError('')}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.total?.[languageObj?.id]}
                                                            value={
                                                                separatorsNumbersSet({
                                                                    number: apartmentReceipt?.total || neutralValue,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - total',
                                                                })?.result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className={apartmentReceipt?.balance === neutralValue ?
                                                            fromControls?.bgTransparentIsValidTextBlackTextRight :
                                                            fromControls?.bgTransparentIsWarningTextBlackTextRight}
                                                            placeholder={labels?.balance?.[languageObj?.id]}
                                                            //onFocus={() => setBuildingContractError('')}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.balance?.[languageObj?.id]}
                                                            value={
                                                                separatorsNumbersSet({
                                                                    number: apartmentReceipt?.balance || neutralValue,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - receiptBalance',
                                                                })?.result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(buildingContractError)}</div> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <ul className='list-unstyled text-muted'>
                                                        <li>{labels?.status?.[languageObj?.id]}: {
                                                            HtmlParser(
                                                                setBadgeStatus({
                                                                    type: isUndNullEmp({ data: receipt?.id, subMethod: 'li - receiptStatus', })?.result ?
                                                                        2 :
                                                                        receipt?.isOpen ?
                                                                            0 :
                                                                            !receipt?.isOpen ? 1 : 2,
                                                                    languageId: languageObj?.id,
                                                                    subMethod: 'li - receiptStatus',
                                                                })
                                                            )
                                                        }
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group text-right'>
                                                    <button id={controls?.buttons?.apartmentReceiptDetailFind?.id}
                                                        className={controls?.buttons?.apartmentReceiptDetailFind?.className}
                                                        disabled={
                                                            isUndNullEmp({ data: apartment?.id, subMethod: 'btn - apartmentReceiptDetailFind', })?.result
                                                        }
                                                        onClick={() => apartmentReceiptGetAsync({
                                                            id: objFind?.id,
                                                            description: objFind?.description,
                                                            rowIndex: objFind?.rowIndex,
                                                            processType: 0,
                                                            subMethod: 'btn - apartmentReceiptDetailFind',
                                                        })}
                                                        hidden={true}
                                                        title={`${labels?.search?.[languageObj?.id]} (${labels?.receiptDetail?.[languageObj?.id]?.toLowerCase()} ${labels?.apartment?.[languageObj?.id]?.toLowerCase()})`}
                                                        type='button'>
                                                        <i id={controls?.icons?.apartmentReceiptDetailFind?.id} className={controls?.icons?.apartmentReceiptDetailFind?.className} /> <span id={controls?.spinners?.apartmentReceiptDetailFind?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.apartmentReceiptDetailDelete?.id}
                                                        className={controls?.buttons?.apartmentReceiptDetailDelete?.className}
                                                        disabled={
                                                            btnApartementReceiptDetailsIsDisable ||
                                                            !receipt?.isOpen ||
                                                            apartmentReceipt?.balance !== apartmentReceipt?.total ||
                                                            isUndNullEmp({ data: receipt?.id, subMethod: currentMethod, })?.result ||
                                                            isUndNullEmp({ data: apartmentReceipt?.id, subMethod: currentMethod, })?.result
                                                        }
                                                        onClick={(e) => apartmentReceiptDetailDeletePostAsync({
                                                            e: e,
                                                            id: objFind?.id,
                                                            description: objFind?.description,
                                                            rowIndex: objFind?.rowIndex,
                                                            subMethod: objFind?.subMethod,
                                                        })}
                                                        hidden={true}
                                                        type='button'
                                                        title={`${labels?.delete?.[languageObj?.id]} (${labels?.receiptDetail?.[languageObj?.id]?.toLowerCase()} ${labels?.apartment?.[languageObj?.id]?.toLowerCase()})`}>
                                                        <i id={controls?.icons?.apartmentReceiptDetailDelete?.id} className={controls?.icons?.apartmentReceiptDetailDelete?.className} /> <span id={controls?.spinners?.apartmentReceiptDetailDelete?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.apartmentReceiptDetailAdd?.id}
                                                        className={controls?.buttons?.apartmentReceiptDetailAdd?.className}
                                                        disabled={
                                                            btnApartementReceiptDetailsIsDisable ||
                                                            !receipt?.isOpen ||
                                                            apartmentReceipt?.balance !== apartmentReceipt?.total ||
                                                            isUndNullEmp({ data: receipt?.id, subMethod: currentMethod, })?.result ||
                                                            isUndNullEmp({ data: apartmentReceipt?.id, subMethod: currentMethod, })?.result
                                                        }
                                                        onClick={(e) => receiptApartmentAddDetailGetAsync({ e: e, subMethod: 'btn - apartmentReceiptDetialAdd', })}
                                                        tooltip='tooltip'
                                                        title={labels?.addDetail}
                                                        type='button'>
                                                        <i id={controls?.icons?.apartmentReceiptDetailAdd?.id} className={controls?.icons?.apartmentReceiptDetailAdd?.className} /> <span id={controls?.spinners?.apartmentReceiptDetailAdd?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.apartmentReceiptPrint?.id}
                                                        className={controls?.buttons?.apartmentReceiptPrint?.className}
                                                        disabled={
                                                            btnApartementReceiptDetailsIsDisable ||
                                                            receipt?.isOpen ||
                                                            apartmentReceipt?.balance > neutralValue ||
                                                            isUndNullEmp({ data: receipt?.id, subMethod: currentMethod, })?.result ||
                                                            isUndNullEmp({ data: apartmentReceipt?.id, subMethod: currentMethod, })?.result ||
                                                            receiptPaymentPrintDisabled
                                                        }
                                                        onClick={(e) => apartmentReceiptPrintAsync({ e: e, subMethod: 'btn - apartmentReceip', })}
                                                        title={labels?.printReceipt}
                                                        type='button'>
                                                        <i id={controls?.icons?.apartmentReceiptPrint?.id} className={controls?.icons?.apartmentReceiptPrint?.className} /> <span id={controls?.spinners?.apartmentReceiptPrint?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtReceiptId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'></div> */}
                                </div>{/*card*/}
                            </div>

                            {/*payments*/}
                            <div className='col-md-6'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.payments}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.payments?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.paymentsLogo}></img> - {labels?.payments?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <button id={controls?.buttons?.apartmentReceiptPaymentAdd?.id}
                                                            className={controls?.buttons?.apartmentReceiptPaymentAdd?.className}
                                                            disabled={receiptIsOpen ||
                                                                apartmentReceiptPaymentIsDisabled ||
                                                                !(apartmentReceipt?.balance > neutralValue)
                                                            }
                                                            onClick={(e) => paymentAddGetAsync({ e: e, subMethod: 'btn - apartmentReceiptPaymentAdd', })}
                                                            tooltip='tooltip'
                                                            title={labels?.add?.[languageObj?.id]}>
                                                            {/* <i className={icons?.plusCircle}></i> */}
                                                            <i id={controls?.icons?.apartmentReceiptPaymentAdd?.id} className={controls?.icons?.apartmentReceiptPaymentAdd?.className} /> <span id={controls?.spinners?.apartmentReceiptPaymentAdd?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.apartmentReceiptPaymentDelete?.id}
                                                            className={controls?.buttons?.apartmentReceiptPaymentDelete?.className}
                                                            disabled={isUndNullEmp({ data: apartmentReceipt?.id, subMethod: 'btn - apartmentReceiptPaymentDelete', })?.result}
                                                            hidden={true}
                                                            onClick={(e) => paymentDeleteAsync({ e: e, subMethod: 'btn - apartmentReceiptPaymentDelete', })}
                                                            tooltip='tooltip'
                                                            title={labels?.delete?.[languageObj?.id]}>
                                                            <i id={controls?.icons?.apartmentReceiptPaymentDelete?.id} className={controls?.icons?.apartmentReceiptPaymentDelete?.className} /> <span id={controls?.spinners?.apartmentReceiptPaymentAdd?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.apartmentReceiptPaymentAttachmentFiles?.id}
                                                            className={controls?.buttons?.apartmentReceiptPaymentAttachmentFiles?.className}
                                                            disabled={isUndNullEmp({ data: apartmentReceipt?.id, subMethod: 'btn - apartmentReceiptPaymentDelete', })?.result}
                                                            hidden={true}
                                                            onClick={(e) => apartmentPaymentFiles({ e: e, subMethod: 'btn - apartmentReceiptPaymentAttachmentFiles', })}
                                                            tooltip='tooltip'
                                                            title={labels?.attachments?.[languageObj?.id]}>
                                                            <i id={controls?.icons?.apartmentReceiptPaymentAttachmentFiles?.id} className={controls?.icons?.apartmentReceiptPaymentAttachmentFiles?.className} /> <span id={controls?.spinners?.apartmentReceiptPaymentAttachmentFiles?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input className={fromControls?.bgTransparentIsValidTextBlackTextRight}
                                                            placeholder={labels?.totalPayments?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.totalPayments?.[languageObj?.id]}
                                                            value={
                                                                separatorsNumbersSet({
                                                                    number: totalPayments || neutralValue,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - totalPayments',
                                                                })?.result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            {/* <div className='col-md-3'><div className='form-group'>{labels?.legend?.es} :</div></div> */}
                                            <div className='col-md-4'>
                                                <div className='form-group text-muted text-center'>
                                                    {HtmlParser(`<i class='${icons?.fasFa?.tag} text-primary'></i>${globalSettings?.html?.space?.formatOne}${labels?.unreconciled?.[languageObj?.id]}`)}
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='form-group text-muted text-center'>
                                                    {HtmlParser(`<i class='${icons?.fasFa?.tag} text-success'></i>${globalSettings?.html?.space?.formatOne}${labels?.conciled?.[languageObj?.id]}`)}
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='form-group text-muted text-center'>
                                                    {HtmlParser(`<i class='${icons?.fasFa?.tag} text-warning'></i>${globalSettings?.html?.space?.formatOne}${labels?.correct?.[languageObj?.id]}`)}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtPaymentsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'></div> */}
                                </div>{/*card*/}
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>

            {apartmentReceiptDetailEditShowModal ?
                <ReceiptPerApartmentDetailEdit $={$}
                    auth={auth}
                    buildingBalance={buildingBalance}
                    setBuildingBalance={setBuildingBalance}
                    buildingBalanceSetAsync={buildingBalanceSetAsync}
                    receipt={receipt}
                    apartmentReceiptDetail={apartmentReceiptDetail}
                    setApartmentReceiptDetail={setApartmentReceiptDetail}
                    dtApartemReceiptDetailRowIndex={dtApartemReceiptDetailRowIndex}
                    apartment={apartment}
                    apartmentBalance={apartmentBalance}
                    setApartmentBalance={setApartmentBalance}
                    apartmentReceipt={apartmentReceipt}
                    setApartmentReceipt={setApartmentReceipt}
                    dtApartmentsId={dtApartmentsId}
                    dtApartmentsRowIndex={dtApartmentsRowIndex}
                    dtReceiptsId={dtReceiptsId}
                    dtReceiptsRowIndex={dtReceiptsRowIndex}
                    dtReceiptId={dtReceiptId}
                    showModal={apartmentReceiptDetailEditShowModal}
                    setShowModal={setApartmentReceiptDetailEditShowModal}
                    languageObj={languageObj} />
                :
                <></>
            }

            {paymentShowModal ?
                <PaymentApartmentAddEditDetails $={$}
                    auth={auth}
                    buildingBalance={buildingBalance}
                    setBuildingBalance={setBuildingBalance}
                    buildingBalanceSetAsync={buildingBalanceSetAsync}
                    receipt={receipt}
                    dtReceiptsId={dtReceiptsId}
                    dtReceiptsRowIndex={dtReceiptsRowIndex}
                    payment={apartmentReceiptPayment}
                    setPayment={setApartmentReceiptPayment}
                    totalPayments={totalPayments}
                    setTotalPayments={setTotalPayments}
                    dtPaymentsId={dtPaymentsId}
                    dtPaymentsRowIndex={dtPaymentsRowIndex}
                    apartment={apartment}
                    apartmentBalance={apartmentBalance}
                    setApartmentBalance={setApartmentBalance}
                    apartmentReceipt={apartmentReceipt}
                    setApartmentReceipt={setApartmentReceipt}
                    dtApartmentsId={dtApartmentsId}
                    dtApartmentsRowIndex={dtApartmentsRowIndex}
                    banks={banks}
                    banksDestiny={banksDestiny}
                    bankAccounts={bankAccounts}
                    paymentMethods={paymentMethods}
                    showModal={paymentShowModal}
                    setShowModal={setPaymentShowModal}
                    processType={processType}
                    setProcessType={setProcessType}
                    languageObj={languageObj} />
                :
                <></>
            }

            {apartmentReceiptPaymentFileShowModal ?
                <PaymentApartmentFiles $={$}
                    auth={auth}
                    showModal={apartmentReceiptPaymentFileShowModal}
                    setShowModal={setApartmentReceiptPaymentFileShowModal}
                    apartmentReceipt={apartmentReceipt}
                    apartmentReceiptPayment={apartmentReceiptPayment}
                    apartmentReceiptPaymentFile={apartmentReceiptPaymentFile}
                    setApartmentReceiptPaymentFile={setApartmentReceiptPaymentFile}
                    languageObj={languageObj} />
                :
                <></>
            }

            {/* {modalLoading.show ?
                <LoadingModalShow modalLoading={modalLoading}
                    setModalLoading={setModalLoading} />
                :
                <></>
            } */}

            {conceptAddShowModal ?
                <ReceiptPerApartmentDetailAdd $={$}
                    auth={auth}
                    buildingBalance={buildingBalance}
                    setBuildingBalance={setBuildingBalance}
                    buildingBalanceSetAsync={buildingBalanceSetAsync}
                    receipt={receipt}
                    receiptPaymentPrint={receiptPaymentPrintDisabled}
                    apartment={apartment}
                    apartmentBalance={apartmentBalance}
                    setApartmentBalance={setApartmentBalance}
                    apartmentReceipt={apartmentReceipt}
                    setApartmentReceipt={setApartmentReceipt}
                    apartmentReceiptDetails={apartmentReceiptDetails}
                    setApartmentReceiptDetails={setApartmentReceiptDetails}
                    dtConceptsId={dtConceptsId}
                    concepts={concepts}
                    conceptsDt={conceptsDt}
                    conceptsGetAsync={conceptsGetAsync}
                    dtApartmentsId={dtApartmentsId}
                    dtApartmentsRowIndex={dtApartmentsRowIndex}
                    dtReceiptsId={dtReceiptsId}
                    dtReceiptsRowIndex={dtReceiptsRowIndex}
                    dtReceiptId={dtReceiptId}
                    showModal={conceptAddShowModal}
                    setShowModal={setConceptAddShowModal}
                    btnIsDisable={btnApartementReceiptDetailsIsDisable}
                    btnARPAddIsDisabled={apartmentReceiptPaymentIsDisabled}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}